/* eslint-disable max-lines */
/* eslint-disable max-depth */
/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import { AgGridAngular } from '@ag-grid-community/angular';
import {
  CellClassParams,
  ColDef,
  ColGroupDef,
  ExcelExportParams,
  FilterChangedEvent,
  FirstDataRenderedEvent,
  GridApi,
  GridOptions,
  GridReadyEvent,
  IRowNode,
  PostProcessPopupParams,
  ProcessCellForExportParams,
  RowClassParams,
  RowStyle,
  ValueFormatterParams,
  ValueGetterParams,
} from '@ag-grid-community/core';
import { CdkConnectedOverlay, CdkOverlayOrigin, ConnectedPosition } from '@angular/cdk/overlay';
import { AsyncPipe, NgClass } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  computed,
  DestroyRef,
  effect,
  inject,
  OnInit,
  QueryList,
  signal,
  TemplateRef,
  untracked,
  ViewChildren,
} from '@angular/core';
import { takeUntilDestroyed, toObservable, toSignal } from '@angular/core/rxjs-interop';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ChartConfiguration, ChartDataset } from 'chart.js';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import { Dictionary, isEqual } from 'lodash';
import { groupBy, isArray, isString, merge, round, sumBy, uniq, uniqBy } from 'lodash-es';
import { NgChartsModule } from 'ng2-charts';
import {
  BehaviorSubject,
  combineLatest,
  EMPTY,
  firstValueFrom,
  from,
  Observable,
  of,
  ReplaySubject,
  merge as rxMerge,
  Subject,
} from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  startWith,
  switchMap,
  take,
  tap,
} from 'rxjs/operators';
import { v4 as uuidv4 } from 'uuid';

import { ToggleBudgetCurrencyComponent } from '@widgets/budget-toggle-currency/toggle-budget-currency.component';

import {
  AgBeCheckboxGroupRendererComponent,
  ICheckboxCellRendererParams,
} from '@features/ag-be-checkbox-group-renderer/ag-be-checkbox-group-renderer.component';
import {
  AgBudgetAttributeComponentParams,
  AgBudgetGroupHeaderComponent,
} from '@features/ag-budget-group-header/ag-budget-group-header.component';
import { BudgetGridService } from '@features/budget/services/budget-grid.service';
import { BudgetService } from '@features/budget/services/budget.service';
import { SnapshotService } from '@features/budget/services/snapshot.service';
import {
  attributeColumnDef,
  getAttributeColumns,
} from '@features/budget-attributes/services/budget-attributes.service';
import { ExportExcelButtonComponent } from '@features/export-excel-button/export-excel-button.component';
import { BeActivitiesAttributesModalRowData } from '@features/inline-budget/be-activities-attributes-modal/be-activities-attributes-modal.model';
import { BeInlineCategoryDropdownOption } from '@features/inline-budget/be-inline-category-dropdown/be-inline-category-dropdown.model';
import { injectOpenActivitiesModal } from '@features/inline-budget/inline-budget-modal';
import { ProgressTrackerComponent } from '@features/progress-tracker/progress-tracker.component';
import { fetchInProgressEvents } from '@features/progress-tracker/utils/fetch-in-progress-events';
import { SnapshotModalComponent } from '@features/snapshot-modal/snapshot-modal.component';
import { VariationStatusComponent } from '@features/variation-status/variation-status.component';

import { ExtendedBudgetData } from '@models/budget/budget.model';
import { BudgetQuery } from '@models/budget/budget.query';
import { BudgetStore } from '@models/budget/budget.store';
import { injectListOrganizationsWithTotalsQuery } from '@models/organization/list-organizations-with-totals.query';

import { AgHeaderDropdownComponent } from '@shared/ag-components/ag-header-dropdown/ag-header-dropdown.component';
import { ButtonComponent } from '@shared/components/button/button.component';
import {
  AuxButtonGroup,
  ButtonGroupComponent,
} from '@shared/components/button-group/button-group.component';
import { CheckboxComponent } from '@shared/components/checkbox/checkbox.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { MenuComponent } from '@shared/components/menu/menu.component';
import { ConfirmationModalComponent } from '@shared/components/modals/confirmation-modal/confirmation-modal.component';
import { VendorDropdownComponent } from '@shared/components/vendor-dropdown/vendor-dropdown.component';
import { MessagesConstants } from '@shared/constants/messages.constants';
import { TableConstants } from '@shared/constants/table.constants';
import { NoopValueAccessorDirective } from '@shared/directives/noop-value-accessor.directive';
import { StickyGridDirective } from '@shared/directives/sticky-grid/sticky-grid.directive';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import {
  Activity,
  ActivitySubType,
  ActivityType,
  AuxBudgetCategoryData,
  BudgetActivityAttributes,
  BudgetHeader,
  BudgetType,
  CategoryType,
  CreateUserCustomViewInput,
  Currency,
  EntityType,
  EventType,
  GqlService,
  OrganizationType,
  PermissionType,
  TrialPreferenceType,
  UpdateUserCustomViewInput,
  UserCustomView,
  ViewLocation,
  WorkflowStep,
} from '@shared/services/gql.service';
import { injectFlags, LaunchDarklyService } from '@shared/services/launch-darkly.service';
import { OverlayService } from '@shared/services/overlay.service';
import { AuthService, injectPermissions } from '@shared/store/auth/auth.service';
import { BudgetCurrencyType } from '@shared/store/budget-currency/budget-currency.model';
import { EventTrackerService } from '@shared/store/event/event-tracker.service';
import { EventQuery } from '@shared/store/event/event.query';
import { EventService } from '@shared/store/event/event.service';
import { GlobalStore } from '@shared/store/global/global.store';
import { MainQuery } from '@shared/store/main/main.query';
import { OrganizationStore } from '@shared/store/organization/organization.store';
import { WorkflowQuery } from '@shared/store/workflow/workflow.query';
import { WorkflowService } from '@shared/store/workflow/workflow.service';
import {
  AgSetColumnsVisible,
  AuxExcelFormats,
  AuxExcelStyleKeys,
  AuxExcelStyles,
  decimalAdd,
  decimalDifference,
  decimalDivide,
  decimalMultiply,
  decimalRoundingToNumber,
  GetExcelStyle,
  isEven,
} from '@shared/utils';
import { getEncodedAttributeName } from '@shared/utils/get-encoded-attribute-name';
import { PeriodType, RequireSome, Utils } from '@shared/utils/utils';

import { BudgetEnhancedHeaderDropdownService } from './budget-enhanced-header-dropdown.service';
import { BudgetUploadComponent } from './budget-upload/budget-upload.component';
import {
  ColumnChooserLegacyComponent,
  VisibleColumns,
} from './column-chooser-component/column-chooser.component';
import {
  actualsToDateColumnDef,
  CellSize,
  getCellClass,
  overallBudgetColumnDef,
  period_sorting,
  remainingBudgetColDef,
  rowGroupsColumnDef,
  uomHide$,
} from './column-defs';
import { CompareDropdownComponent } from './compare-dropdown/compare-dropdown.component';
import { BudgetCustomCreateComponent } from './components/budget-custom-create.component';
import { BudgetCustomUpdateComponent } from './components/budget-custom-update.component';
import { agBudgetCurrencyFormatter } from './utils/budget-formatters.utils';

dayjs.extend(quarterOfYear);
dayjs.extend(isSameOrAfter);

// localstorage key for Budget attributes
const BEAttributesLSKey = 'budget_enhanced_header';

interface ActivityWithAttributes extends Omit<Activity, '__typename'> {
  activity_sub_type?: ActivitySubType;
  category_full_path: string;
}

type BudgetChartData = { data: number; discountData: number }[];

@Component({
  imports: [
    NoopValueAccessorDirective,
    VendorDropdownComponent,
    FormsModule,
    ReactiveFormsModule,
    TooltipDirective,
    CompareDropdownComponent,
    NgSelectComponent,
    IconComponent,
    MenuComponent,
    ProgressTrackerComponent,
    NgChartsModule,
    NgClass,
    CdkOverlayOrigin,
    CdkConnectedOverlay,
    ButtonComponent,
    CheckboxComponent,
    ToggleBudgetCurrencyComponent,
    ButtonGroupComponent,
    ExportExcelButtonComponent,
    AgGridAngular,
    StickyGridDirective,
    AsyncPipe,
  ],
  providers: [BudgetEnhancedHeaderDropdownService],
  selector: 'aux-budget-enhanced',
  styleUrls: ['./budget-enhanced.component.css'],
  templateUrl: './budget-enhanced.component.html',
})
export class BudgetEnhancedComponent implements OnInit {
  public authService = inject(AuthService);
  public budgetQuery = inject(BudgetQuery);
  destroyRef = inject(DestroyRef);
  globalStore = inject(GlobalStore);

  private budgetGridService = inject(BudgetGridService);
  private budgetService = inject(BudgetService);
  private budgetStore = inject(BudgetStore);
  private cdr = inject(ChangeDetectorRef);
  private eventQuery = inject(EventQuery);
  private eventService = inject(EventService);
  private eventTrackerService = inject(EventTrackerService);
  private gqlService = inject(GqlService);
  private HeaderDropdownService = inject(BudgetEnhancedHeaderDropdownService);
  private launchDarklyService = inject(LaunchDarklyService);
  private mainQuery = inject(MainQuery);
  private organizationStore = inject(OrganizationStore);
  private overlayService = inject(OverlayService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private snapshotService = inject(SnapshotService);
  private workflowQuery = inject(WorkflowQuery);
  private workflowService = inject(WorkflowService);

  activitiesModal = injectOpenActivitiesModal();
  flags = injectFlags({
    budgetActualsToDateUnits: 'budget_actuals_to_date_units',
    multiVendorBudgetTemplate: 'multi_vendor_budget_template',
    showEditButton: 'budget_edit_button',
  });
  permissions = injectPermissions({
    canEditBudget: 'PERMISSION_EDIT_BUDGET',
  });
  vendorsQuery = injectListOrganizationsWithTotalsQuery();

  gridUniqVendors = signal<string[]>([]);
  selectedNodeCount = signal(0);

  private budgetQueryData = signal<ExtendedBudgetData[]>([]);

  activitiesWithoutMapping = toSignal(
    toObservable(this.activitiesModal.vendor_id).pipe(
      switchMap((vendorId) => {
        if (!vendorId) {
          return of([]);
        }

        return this.gqlService
          .listActivitiesWithInvoiceMappings$({
            vendor_id: vendorId,
          })
          .pipe(map((res) => res.data || []));
      })
    ),
    {
      initialValue: [],
    }
  );

  gridData$ = new BehaviorSubject<ExtendedBudgetData[]>([]);

  gridData = toSignal(this.gridData$, { requireSync: true });

  selectedVendor = new FormControl('');

  selectedVendorSignal = toSignal(this.selectedVendor.valueChanges.pipe(startWith('')), {
    requireSync: true,
  });

  editAttributesDisabled = computed(() => this.selectedNodeCount() === 0);
  getCheckboxTooltipReasons = computed(() => {
    const mainState = this.mainQuery.mainState();
    const reasons: string[] = [];

    if (!this.permissions().canEditBudget) {
      reasons.push(MessagesConstants.DO_NOT_HAVE_PERMISSIONS_TO_ACTION);
    }

    if (!!mainState.trialStartDate === false) {
      reasons.push(MessagesConstants.TIMELINE_MUST_BE_ENTERED);
    }

    if (this.isChangeOrdersWorkflowLocked()) {
      reasons.push(MessagesConstants.LOCKED_FOR_PERIOD_CLOSE);
    }

    return reasons;
  });
  editButtonGroupDisabledReasons = computed(() => {
    const selectedVendor = this.selectedVendorSignal();
    const uniqVendorCount = this.gridUniqVendors().length;

    const reasons: string[] = [...this.getCheckboxTooltipReasons()];

    // if no reasons, then we can show the checkbox tooltip
    if (reasons.length === 0 && selectedVendor === '' && uniqVendorCount > 1) {
      if (this.selectedNodeCount() === 0) {
        reasons.push(
          'Select checkboxes next to at least 1 vendor/activity to edit or select single vendor from dropdown.'
        );
      }
    }

    return reasons;
  });
  editButtonGroupDisabled = computed(() => this.editButtonGroupDisabledReasons().length > 0);

  gridAPI?: GridApi;

  budgetModalRowMap = (rows: BeActivitiesAttributesModalRowData[]) => {
    const activitiesWithoutMapping = this.activitiesWithoutMapping();

    if (activitiesWithoutMapping.length) {
      rows.forEach((row) => {
        row.deletable =
          row.deletable &&
          !activitiesWithoutMapping.find(
            (val) => val.activity_id === row.id && val.activity_name === row.activity_name
          );
      });
    }

    return rows;
  };

  editOptions = computed<AuxButtonGroup[]>(() => {
    const editAttributesDisabled = this.editAttributesDisabled();

    return untracked(() => [
      {
        iconName: 'Plus',
        name: 'Add New Activities',
        onClick: () => {
          const budgetData = this.gridData$.getValue();
          const ref = this.activitiesModal.openModal({
            allBudgetActivities: this.budgetQueryData(),
            budgetData: budgetData,
            editMode: false,
            rows: [],
            uomHide: uomHide$.getValue(),
          });

          if (ref) {
            this.onModalClose(ref).catch(console.error);
          }
        },
      },
      {
        disabled: editAttributesDisabled,
        disabledTooltip: 'Please select activities to edit.',
        iconName: 'Edit',
        name: 'Edit Activities',
        onClick: () => {
          const ref = this.activitiesModal.openModal({
            allBudgetActivities: this.budgetQueryData(),
            budgetData: this.gridData$.getValue(),
            rows: this.budgetModalRowMap(
              this.activitiesModal.mapSelectedRowsToModalData(this.gridAPI!)
            ),
            uomHide: uomHide$.getValue(),
          });

          if (ref) {
            this.onModalClose(ref).catch(console.error);
          }
        },
      },
      {
        disabled: editAttributesDisabled,
        disabledTooltip: 'Please select activities to edit.',
        iconName: 'Hierarchy3',
        name: 'Edit Attributes',
        onClick: () => {
          const ref = this.activitiesModal.openModal({
            allBudgetActivities: this.budgetQueryData(),
            budgetData: this.gridData$.getValue(),
            isActivityTabVisible: false,
            rows: this.budgetModalRowMap(
              this.activitiesModal.mapSelectedRowsToModalData(this.gridAPI!)
            ),
            uomHide: uomHide$.getValue(),
          });

          if (ref) {
            this.onModalClose(ref).catch(console.error);
          }
        },
      },
    ]);
  });
  vendors = computed(() => this.vendorsQuery.data() || []);
  selectedVendorWithTotal = computed(() => {
    const selectedVendor = this.selectedVendorSignal();
    const vendors = this.vendors();

    return vendors.find((v) => v.id === selectedVendor);
  });

  canvasDatasets$ = new BehaviorSubject<ChartDataset<'bar', number[]>[]>([]);
  canvasRefresh$ = new Subject();
  compareToValue?: string = undefined;
  isSnapShotSelected$ = new BehaviorSubject<{
    currentLegend: boolean;
    selected: boolean;
    snapShotLegend: boolean;
  }>({ currentLegend: true, selected: false, snapShotLegend: true });
  selectedPeriodType = new FormControl(
    this.launchDarklyService.flags$.getValue().client_preference_budget_period_type
  );

  private getTimelineHeaders = (monthYears: string[] | undefined) => {
    if (!monthYears) {
      return { months: [], quarters: [], years: [] };
    }

    return {
      months: monthYears,
      quarters: [
        ...new Set(
          monthYears.map((date) => {
            return `Q${dayjs(this.parseBudgetMonthToDate(date)).quarter()} ${dayjs(
              this.parseBudgetMonthToDate(date)
            ).format('YYYY')}`;
          })
        ),
      ],
      years: [
        ...new Set(
          monthYears.map((date) => {
            return dayjs(this.parseBudgetMonthToDate(date)).format('YYYY');
          })
        ),
      ],
    };
  };

  budgetCanvas$: Observable<ChartConfiguration<'bar', number[]>> = combineLatest([
    this.budgetQuery.select(['header_data', 'budget_data']),
    this.canvasRefresh$.pipe(startWith('')),
  ]).pipe(
    map(([state]) => {
      const auxilius_start_date = this.mainQuery.getAuxiliusStartDate();
      const columns = ['Services', 'Investigator', 'Pass-through'];

      const activeOrganizationId = this.selectedVendorSignal();
      const groupedData = groupBy(
        activeOrganizationId
          ? state.budget_data?.filter((bd) => bd.vendor_id === activeOrganizationId)
          : state.budget_data,
        'cost_category'
      );
      const timelineHeaders = this.getTimelineHeaders(
        state.header_data.find((x) => x.group_name === 'Timeline')?.date_headers
      );

      const monthLabels = timelineHeaders.months.filter((str) => {
        if (!auxilius_start_date) {
          return true;
        }

        return dayjs(new Date(`01/${str.replace('-', '/').toUpperCase()}`)).isSameOrAfter(
          dayjs(auxilius_start_date).date(1)
        );
      });

      let xAxisPeriodLabels = monthLabels;
      const selectedPeriod = this.selectedPeriodType.value as PeriodType;

      if (selectedPeriod === PeriodType.PERIOD_QUARTER) {
        xAxisPeriodLabels = timelineHeaders.quarters;
      } else if (selectedPeriod === PeriodType.PERIOD_YEAR) {
        xAxisPeriodLabels = timelineHeaders.years;
      }

      this.isSnapShotSelected$.next({
        currentLegend: true,
        selected: !!this.compareToValue,
        snapShotLegend: true,
      });

      const datasets: ChartDataset<'bar', BudgetChartData>[] = [];

      const colors: Partial<ChartDataset<'bar'>>[] = [
        'rgba(9, 91, 149, 1)',
        'rgba(9, 91, 149, 0.7)',
        'rgba(9, 91, 149, 0.4)',
        'rgba(35,98,98,1)',
        'rgba(35,98,98,0.7)',
        'rgba(35,98,98,0.4)',
      ].map((c) => {
        return {
          backgroundColor: c,
          borderColor: c,
        };
      });

      const setDataSet = (isSnapshot = false) => {
        datasets.push(
          {
            data: xAxisPeriodLabels.map(() => {
              return { data: 0, discountData: 0 };
            }),
            hidden: isSnapshot
              ? !this.isSnapShotSelected$.getValue().snapShotLegend
              : !this.isSnapShotSelected$.getValue().currentLegend,
            label: 'Services',
            stack: !isSnapshot ? 'stack 0' : 'stack 1',
            type: 'bar',
          },
          {
            data: xAxisPeriodLabels.map(() => {
              return { data: 0, discountData: 0 };
            }),
            hidden: isSnapshot
              ? !this.isSnapShotSelected$.getValue().snapShotLegend
              : !this.isSnapShotSelected$.getValue().currentLegend,
            label: 'Investigator',
            stack: !isSnapshot ? 'stack 0' : 'stack 1',
            type: 'bar',
          },
          {
            data: xAxisPeriodLabels.map(() => {
              return { data: 0, discountData: 0 };
            }),
            hidden: isSnapshot
              ? !this.isSnapShotSelected$.getValue().snapShotLegend
              : !this.isSnapShotSelected$.getValue().currentLegend,
            label: 'Pass-through',
            stack: !isSnapshot ? 'stack 0' : 'stack 1',
            type: 'bar',
          }
        );
        columns.map((amtType) => {
          if (groupedData[amtType]) {
            let amtTypeIndex = -1;

            datasets.forEach((item, i) => {
              if (item.label === amtType) {
                amtTypeIndex = i;
              }
            });
            let loopIndex = 0;

            for (const month of monthLabels) {
              let headerStrConversion = month;
              let timelinePeriods = monthLabels;

              if (selectedPeriod === PeriodType.PERIOD_QUARTER) {
                headerStrConversion = `Q${dayjs(
                  this.parseBudgetMonthToDate(month)
                ).quarter()} ${dayjs(this.parseBudgetMonthToDate(month)).format('YYYY')}`;
                timelinePeriods = timelineHeaders.quarters;
              } else if (selectedPeriod === PeriodType.PERIOD_YEAR) {
                headerStrConversion = dayjs(this.parseBudgetMonthToDate(month)).format('YYYY');
                timelinePeriods = timelineHeaders.years;
              }

              const applyData = (arr: number[], index: number) => {
                arr.forEach((v, i) => {
                  datasets[index].data[i].discountData = v;
                });
              };

              const periodIndex = timelinePeriods.indexOf(headerStrConversion);

              if (!isSnapshot) {
                const n = decimalRoundingToNumber(
                  sumBy(groupedData[amtType], `EXPENSE_FORECAST_USD::${month}`) || 0,
                  2
                );

                const wp = decimalRoundingToNumber(
                  sumBy(groupedData[amtType], `EXPENSE_WP_USD::${month}`) || 0,
                  2
                );

                if (amtType === 'Services') {
                  const arr = this.getDiscountDataForCanvas(
                    xAxisPeriodLabels,
                    selectedPeriod,
                    groupedData,
                    isSnapshot
                  );

                  applyData(arr, amtTypeIndex);
                }

                if (periodIndex !== -1 && amtTypeIndex !== -1) {
                  const discountAmount = this.getDiscountAmountForCanvas({
                    amtType,
                    amtTypeIndex,
                    datasets,
                    loopIndex,
                    periodIndex,
                    selectedPeriod,
                  });

                  datasets[amtTypeIndex].data[periodIndex].data += n + wp + discountAmount;
                }
              } else {
                if (amtType === 'Services') {
                  const arr = this.getDiscountDataForCanvas(
                    xAxisPeriodLabels,
                    selectedPeriod,
                    groupedData,
                    isSnapshot
                  );

                  applyData(arr, amtTypeIndex);
                }

                const n =
                  sumBy(groupedData[amtType], `EXPENSE_FORECAST_USD::${month}::SNAPSHOT`) || 0;
                const wp = sumBy(groupedData[amtType], `EXPENSE_WP_USD::${month}::SNAPSHOT`) || 0;

                if (periodIndex !== -1 && amtTypeIndex !== -1) {
                  const discountAmount = this.getDiscountAmountForCanvas({
                    amtType,
                    amtTypeIndex,
                    datasets,
                    loopIndex,
                    periodIndex,
                    selectedPeriod,
                  });

                  if (selectedPeriod === PeriodType.PERIOD_MONTH) {
                    datasets[amtTypeIndex].data[periodIndex].data += decimalRoundingToNumber(
                      /*
                        In snapshot.service getMonthsSnapshotActuals FORECAST numbers are turned into WP numbers,
                        so for the purposes of the monthly graph, we only need one of them
                      */
                      (wp || n) + discountAmount,
                      2
                    );
                  } else {
                    datasets[amtTypeIndex].data[periodIndex].data += decimalRoundingToNumber(
                      n + wp + discountAmount,
                      2
                    );
                  }
                }
              }

              loopIndex += 1;
            }
          }
        });
      };

      setDataSet();

      if (this.compareToValue) {
        setDataSet(true);
      }

      const datasets2 = datasets.map((x, i) => {
        return {
          ...x,
          ...colors[i],
          data: x.data.map((y) => y.data),
        };
      });

      this.canvasDatasets$.next(datasets2);

      return <ChartConfiguration<'bar', number[]>>{
        data: {
          datasets: datasets2,
          labels: xAxisPeriodLabels,
        },
        options: {
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: !this.isSnapShotSelected$.getValue().selected,
            },
            tooltip: {
              callbacks: {
                label: (tooltipItem) => {
                  const dataset = tooltipItem.dataset;
                  const yLabel = tooltipItem.parsed.y;

                  if (dataset.label === 'Services') {
                    const rawDataset = datasets[tooltipItem.datasetIndex];

                    const discountAmount =
                      rawDataset?.data[tooltipItem.dataIndex].discountData || 0;
                    const discountAmountFormatted = Utils.currencyFormatter(discountAmount, {
                      maximumFractionDigits: 0,
                      minimumFractionDigits: 0,
                    });

                    // for the tooltip, we want to show to original value of services so we subtract the discounted amount since the yLabel is services + discount
                    const servicesAmount = Utils.currencyFormatter(yLabel - discountAmount, {
                      maximumFractionDigits: 0,
                      minimumFractionDigits: 0,
                    });

                    const totalAmount = Utils.currencyFormatter(yLabel, {
                      maximumFractionDigits: 0,
                      minimumFractionDigits: 0,
                    });

                    return `${totalAmount} - Services: ${servicesAmount}, Discount: ${discountAmountFormatted}`;
                  }

                  return Utils.currencyFormatter(yLabel, {
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                  });
                },
                title(item) {
                  return item.map((x) => x.dataset.label || '');
                },
              },
            },
          },
          responsive: true,
          scales: {
            x: {
              stacked: true,
            },
            y: {
              axis: 'y',
              stacked: true,
              ticks: {
                // Include a dollar sign in the ticks
                callback: (value) => {
                  return Utils.currencyFormatter(value as number, {
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                  });
                },
              },
            },
          },
        },
        type: 'bar',
      };
    })
  );

  areUnsavedChanges = false;
  autoGroupColumnDef: ColDef = {
    cellClass: TableConstants.STYLE_CLASSES.CELL_ALIGN_LEFT,
    cellRenderer: AgBeCheckboxGroupRendererComponent,
    cellRendererParams: <ICheckboxCellRendererParams>{
      checkboxContainerClass: 'pr-[10px]',
      checkboxTooltip: (params) => {
        const nodes = this.gridAPI?.getSelectedNodes() || [];
        const reasons = this.getCheckboxTooltipReasons();

        if (reasons.length > 0) {
          return reasons;
        }

        if (nodes.length === 0) {
          return [];
        }

        let vendor_id = '';

        if (params.node.group) {
          vendor_id = (params.node.allLeafChildren[0].data as { vendor_id: string })?.vendor_id;
        } else {
          vendor_id = (params.node.data as { vendor_id: string })?.vendor_id;
        }

        if (vendor_id) {
          return nodes.some((n) => n.data.vendor_id === vendor_id)
            ? []
            : ['All selections must be for a single vendor contract.'];
        }

        return [];
      },
      tooltipField: 'activity_name',
    },
    comparator: (_, __, nodeA, nodeB) => {
      if (!nodeA.aggData) {
        return 0;
      }

      return nodeA.aggData.current_lre - nodeB.aggData.current_lre;
    },
    field: 'activity_name',
    headerClass: 'activities-header',
    headerComponent: AgBudgetGroupHeaderComponent,
    headerComponentParams: {
      afterAttrToggle: () => this.loadBudgetGridData(),
      expandLevel: () => (this.selectedVendor.value ? -1 : 1),
      localStorageKey: BEAttributesLSKey,
      template: `Activities`,
    } as AgBudgetAttributeComponentParams,
    headerName: 'Activities',
    minWidth: 250,
    pinned: 'left',
    resizable: true,
    width: 250,
  };
  @ViewChildren('budgetFilters') budgetFilters!: QueryList<TemplateRef<unknown>>;
  budgetGridYears: null | number[] = null;
  columnDefs: (ColDef | ColGroupDef)[] = [];
  customValues$ = new BehaviorSubject<(UserCustomView & { showLine: boolean })[] | null>(null);
  defaultColumns: ((ColDef | ColGroupDef) & {
    children?: ColDef[];
    hideForAllVendorSelection?: boolean;
  })[] = [...rowGroupsColumnDef];
  excelOptions = {
    author: 'Auxilius',
    columnWidth(params) {
      switch (params.column?.getId()) {
        case 'activity_name_label':
          return 490;
        case 'group0':
          return 280;
        case 'vendor_name':
          return 280;
        default:
          return 105;
      }
    },
    fileName: 'auxilius-budget.xlsx',
    fontSize: 11,
    sheetName: 'Vendor Budget',
    shouldRowBeSkipped(params) {
      return !params.node?.data?.cost_category;
    },
  } as ExcelExportParams;
  gridAPI$ = new ReplaySubject<GridApi>(1);
  gridAPIBehavior$ = new BehaviorSubject<GridApi | undefined>(undefined);
  // only needed for Excel export
  isTotalHidden = true;

  isRowSelectable = (node: IRowNode) => {
    const reasons = this.getCheckboxTooltipReasons();

    if (reasons.length > 0) {
      return false;
    }

    const nodes = this.gridAPI?.getSelectedNodes() || [];

    if (nodes.length === 0) {
      return true;
    }

    return nodes.some((n) => n.data.vendor_id === node.data.vendor_id);
  };

  gridOptions: GridOptions = {
    columnDefs: [],
    defaultColDef: {
      cellClassRules: {
        [AuxExcelStyleKeys.BORDER_BOTTOM]: (params) => {
          return (
            !params.node.group &&
            params.node.lastChild &&
            !!params.node.parent?.lastChild &&
            this.isTotalHidden
          );
        },
      },
      resizable: true,
      sortable: false,
      suppressMenu: true,
      suppressMovable: true,
    },
    excelStyles: [
      ...Utils.generateExcelCurrencyStyles(Utils.CURRENCY_OPTIONS),
      ...AuxExcelStyles,
      {
        ...GetExcelStyle(AuxExcelStyleKeys.FIRST_ROW),
        borders: {
          borderBottom: {
            color: 'black',
            lineStyle: 'Continuous',
            weight: 1,
          },
        },
        id: 'trial_name',
      },
      {
        alignment: { horizontal: 'Center' },
        font: { bold: true, color: '#FFFFFF', fontName: 'Arial', size: 11 },
        id: 'header',
        interior: { color: '#094673', pattern: 'Solid' },
      },
      {
        alignment: { horizontal: 'Center' },
        font: { bold: true, color: '#FFFFFF', fontName: 'Arial', size: 11 },
        id: 'headerGroup',
        interior: { color: '#999999', pattern: 'Solid' },
      },
      {
        dataType: 'Number',
        id: 'budget-cost',
        numberFormat: { format: AuxExcelFormats.Cost },
      },
      {
        dataType: 'Number',
        id: 'budgetCostNoSymbol',
        numberFormat: { format: AuxExcelFormats.Units },
      },
      {
        font: { fontName: 'Arial', size: 11 },
        id: 'cell',
      },
      {
        alignment: { horizontal: 'Right' },
        id: 'budget-percent',
        numberFormat: { format: AuxExcelFormats.Percent },
      },
      {
        dataType: 'Number',
        id: 'budget-percent-no-mult',
        numberFormat: { format: AuxExcelFormats.PercentWithout100Mult },
      },
      {
        alignment: { horizontal: 'Right' },
        id: 'budget-units',
        numberFormat: { format: AuxExcelFormats.Units },
      },
      {
        font: { bold: true, color: '#000000', fontName: 'Arial', size: 11 },
        id: 'total_row_header',
        interior: { color: '#D9D9D9', pattern: 'Solid', patternColor: '#D9D9D9' },
      },
      {
        font: { bold: true, color: '#000000', fontName: 'Arial', size: 11 },
        id: 'total_row',
        interior: { color: '#D9D9D9', pattern: 'Solid', patternColor: '#D9D9D9' },
        numberFormat: { format: AuxExcelFormats.Units },
      },
      {
        dataType: 'Number',
        font: { bold: true, color: '#000000', fontName: 'Arial', size: 11 },
        id: 'total_row_percent',
        interior: { color: '#D9D9D9', pattern: 'Solid', patternColor: '#D9D9D9' },
        numberFormat: { format: AuxExcelFormats.Percent },
      },
    ],
    getRowClass: (params: RowClassParams): string => {
      let childrenIndex;

      if (this.selectedVendor.value === '') {
        childrenIndex = Utils.getParentIndex(params.node);
      } else if (params.node.level === 1) {
        childrenIndex = params.node.childIndex;
      } else {
        childrenIndex = Utils.getParentIndex(params.node, 1);

        if (params.node.level >= 2) {
          const getParentNode = ({
            levelToReturn,
            node,
          }: {
            levelToReturn: number;
            node?: IRowNode | null;
          }): IRowNode => {
            if (node?.level === levelToReturn) {
              return node;
            }

            return getParentNode({ levelToReturn, node: node?.parent });
          };

          const node = getParentNode({ levelToReturn: 2, node: params.node });

          childrenIndex = node.childIndex;
          const isEven = (node.parent?.childIndex || 0) % 2;

          if (isEven === 1) {
            return childrenIndex % 2
              ? TableConstants.STYLE_CLASSES.IS_ODD
              : TableConstants.STYLE_CLASSES.IS_EVEN;
          }
        }
      }

      return childrenIndex % 2
        ? TableConstants.STYLE_CLASSES.IS_EVEN
        : TableConstants.STYLE_CLASSES.IS_ODD;
    },
    getRowStyle: (params: RowClassParams) => {
      // total row
      if (params.node.level < 0) {
        return <RowStyle>{
          display: 'none',
        };
      }

      return {};
    },
    groupIncludeTotalFooter: true,
    groupSelectsChildren: true,
    isRowSelectable: (node) => this.isRowSelectable(node),
    rowSelection: 'multiple',
    suppressAggFuncInHeader: true,
    suppressCellFocus: true,
    suppressColumnVirtualisation: true,
    suppressMenuHide: true,
    suppressPropertyNamesCheck: true,
    suppressRowClickSelection: true,
    tooltipShowDelay: 500,
  };
  gridOptions$ = new BehaviorSubject<GridOptions>(this.gridOptions);
  highlightedCustom = new BehaviorSubject<null | number>(null);
  invoicesTotalLoading = new BehaviorSubject(false);
  isChangeOrdersWorkflowLocked = this.workflowQuery.getLockStatusByWorkflowStepType(
    WorkflowStep.WF_STEP_MONTH_CLOSE_LOCK_CHANGE_ORDERS
  );
  isCustomOpen = false;
  isVendorCurrenciesUSD = true;
  isVendorCurrency = true;
  isYearsOpen = false;
  readonly messagesConstants = MessagesConstants;
  modelUpdated$ = new BehaviorSubject(false);
  modelUpdatedDebounced$ = new BehaviorSubject(false);
  multiProgressTrackerId = fetchInProgressEvents(
    EventType.MULTI_VENDOR_BUDGET_TEMPLATE_UPLOADED,
    this.destroyRef
  );
  numberOfVendorCurrencies = 0;
  pendingChangesLoading = new BehaviorSubject(false);
  periodTypes = [
    { label: 'Month', value: PeriodType.PERIOD_MONTH },
    { label: 'Quarter', value: PeriodType.PERIOD_QUARTER },
    { label: 'Year', value: PeriodType.PERIOD_YEAR },
  ];
  positions: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top',
    },
  ];
  progressTrackerId = fetchInProgressEvents(EventType.BUDGET_TEMPLATE_UPLOADED, this.destroyRef);
  refreshGrid$ = new Subject();
  selectedBudgetCurrencyType$ = new BehaviorSubject<BudgetCurrencyType>(BudgetCurrencyType.VENDOR);
  selectedCustom$ = new BehaviorSubject('');
  selectedCustomIndex: null | number = null;
  selectedYear!: string;
  showAnalyticsSection$: Observable<boolean>;
  showBudgetGraph = localStorage.getItem('showBudgetGraph')
    ? localStorage.getItem('showBudgetGraph') === 'true'
    : true;
  showBudgetTypeSelect$: Observable<boolean>;
  showGrid$ = new BehaviorSubject(false);
  showSnapshotSection$ = this.launchDarklyService.select$(
    (flags) => flags.section_budget_snapshots
  );
  timelineExist$ = this.mainQuery.selectTimelineExist();
  userHasEditPermissions = false;
  userHasUploadBudgetPermission = false;
  vendorCurrencyEnabled$: Observable<boolean>;
  visibleColumns: VisibleColumns = {
    actuals_to_date: {
      costs: true,
      perc: true,
      units: true,
    },
    current_period: {
      months: true,
      quarters: true,
    },
    forecast: {
      months: true,
      quarters: true,
      years: true,
    },
    historicals: {
      months: true,
      quarters: true,
      years: true,
    },
    overall_budget: {
      original: true,
      primary: true,
      unit_cost: true,
      units: true,
      var_cost: true,
      var_perc: true,
    },
    remaining_budget: {
      costs: true,
      perc: true,
      units: true,
    },
  };
  wpLoading = new BehaviorSubject(false);
  years: { enabled: boolean; label: number }[] = [];
  zeroHyphen = Utils.zeroHyphen;

  ngOnInit() {
    this.selectedBudgetCurrencyType$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((x) => {
      this.isVendorCurrency = x === BudgetCurrencyType.VENDOR;
    });

    // Subscribing to modelUpdated changes
    // so that cellRenderers have a way to "refresh",
    // even if agInit isn't called.
    // This is required for supporting auto-qa attributes
    // on tables with grouped rows.
    this.modelUpdatedListener();

    combineLatest([
      this.selectedVendor.valueChanges.pipe(
        // ignore if the value is the same as the previous value
        distinctUntilChanged()
      ),
      this.budgetQuery.select('budget_type'),
    ])
      .pipe(takeUntilDestroyed(this.destroyRef), debounceTime(0))
      .subscribe(() => {
        // each of the observables above will trigger a budget reloading,
        // so we need to hard refresh the ag-grid to fix the total row issue
        // if we keep the showGrid as true when we call the loadBudgetGridData method
        // we can still see the old grid in the html. Method will refresh the grid itself but
        // this will cause the grid to blink so to fix that
        // I'm setting this variable false here
        this.showGrid$.next(false);
      });

    this.selectedPeriodType.valueChanges
      .pipe(startWith(this.selectedPeriodType.value))
      .subscribe(() => {
        this.budgetStore.update({ ...this.budgetQuery.getValue() });
        this.canvasRefresh$.next(null);
      });

    this.selectedPeriodType.patchValue(PeriodType.PERIOD_MONTH);

    this.refreshGrid$
      .pipe(startWith(true))
      .pipe(
        switchMap(() => {
          this.globalStore.refreshRequest('TrialAttributes');

          return from(this.vendorsQuery.refetch()).pipe(
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            tap(async (query) => {
              const vendors = query.data || [];
              const { modalVendorId, vendorId } = await firstValueFrom(this.route.queryParams);

              const uniqVendorCurrencies = uniq(
                vendors
                  .filter(
                    (x) =>
                      x.organization_type === OrganizationType.ORGANIZATION_VENDOR &&
                      x.current_budget_versions.length > 0
                  )
                  .map((x) => x.currency)
              );

              this.numberOfVendorCurrencies = uniqVendorCurrencies.length;
              this.isVendorCurrenciesUSD = uniqVendorCurrencies.every(
                (currency) => currency === Currency.USD
              );

              if (vendors.length === 1) {
                this.organizationStore.setActive(vendors[0].id);
                this.selectedVendor.setValue(vendors[0].id);
              } else {
                // reset any older selected vendors.
                const selectedVendorId = localStorage.getItem('selectedVendor');
                const anyEditActivities = localStorage.getItem('anyEditActivities');

                if (selectedVendorId && anyEditActivities) {
                  // if the selected vendor is not in the list of vendors, we need to remove the selected vendor from the local storage
                  const selectedVendor = vendors.find((v) => v.id === selectedVendorId);

                  if (selectedVendor) {
                    this.organizationStore.setActive(selectedVendor.id);
                    this.selectedVendor.setValue(selectedVendor.id);
                    localStorage.removeItem('anyEditActivities');
                  } else {
                    localStorage.removeItem('selectedVendor');
                  }
                } else {
                  const targetVendorId = modalVendorId || vendorId || this.selectedVendor.value;
                  const targetVendor = vendors.find((v) => v.id === targetVendorId);

                  if (targetVendor) {
                    this.organizationStore.setActive(targetVendor.id);
                    this.selectedVendor.setValue(targetVendor.id);
                  } else {
                    this.organizationStore.setActive(null);
                    this.selectedVendor.setValue('');
                  }
                }
              }

              if (modalVendorId) {
                this.activitiesModal.vendor_id.set(modalVendorId);

                const sleep = async (ms = 500) => {
                  if (this.activitiesModal.categoriesLoading()) {
                    await sleep(ms);
                  }
                };

                // if categories are loading, wait for them to load
                await sleep();

                const ref = this.activitiesModal.openModal({
                  allBudgetActivities: this.budgetQuery.getValue().budget_data,
                  budgetData: this.gridData$.getValue(),
                  editMode: false,
                  isActivityTabVisible: true,
                  rows: [],
                  uomHide: uomHide$.getValue(),
                });

                if (ref) {
                  this.onModalClose(ref).catch(console.error);
                }

                this.router
                  .navigate([], {
                    queryParams: { modalVendorId: null },
                    queryParamsHandling: 'merge',
                  })
                  .catch(console.error);
              }
            })
          );
        })
      )
      .pipe(
        switchMap(() => {
          return this.budgetService.getBudgetDataForEBGV2();
        }),
        switchMap(() => {
          if (this.compareToValue) {
            return this.snapshotService.getBudgetSnapshots(this.compareToValue);
          }

          return of();
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();

    this.workflowService.getWorkflowList().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }

  static agCurrencyFormatter(val: ValueFormatterParams) {
    if (val.data) {
      if (val.data.expense_note && (val.colDef.field || '').indexOf('direct_cost') >= 0) {
        return val.data.expense_note;
      }
    }

    if (val.value) {
      if (!Number.isNaN(val.value)) {
        return Utils.currencyFormatter(val.value);
      }
    }

    return Utils.zeroHyphen;
  }

  private aggregateQuartersAndYears(
    budget_data: ExtendedBudgetData[],
    header_data: RequireSome<BudgetHeader, 'date_headers'>[]
  ) {
    const auxilius_start_date = this.mainQuery.getAuxiliusStartDate();
    const f_header = header_data.find((el) => el.expense_type === 'EXPENSE_FORECAST');
    const forecast_header = {
      ...f_header,
      date_headers: Object.assign([], f_header?.date_headers),
    };
    const h_header = header_data.find((el) => el.expense_type === 'EXPENSE_WP');
    const historical_header = {
      ...h_header,
      date_headers: Object.assign([], h_header?.date_headers),
    };
    const remaining_header = header_data.filter(
      (el) => el.expense_type !== 'EXPENSE_FORECAST' && el.expense_type !== 'EXPENSE_WP'
    );
    const bud_data: ExtendedBudgetData[] = budget_data.map((bd) => {
      const obj: { [key: string]: number } = {};

      Object.keys(bd)
        .filter((key) => key.startsWith('EXPENSE_FORECAST::') && !key.endsWith('::SNAPSHOT'))
        .forEach((key) => {
          const splitkey = key.split('::');
          const date = dayjs(`01/${splitkey[1].replace('-', '/')}`);

          if (isNaN(date.year())) {
            return;
          }

          const yearKey = `EXPENSE_FORECAST::${date.year()}` as const;

          if (!bd[yearKey]) {
            if (obj[yearKey]) {
              obj[yearKey] += <number>bd[key];
            } else {
              obj[yearKey] = <number>bd[key];

              if (!forecast_header?.date_headers.find((h: string) => h === `${date.year()}`)) {
                forecast_header?.date_headers.push(`${date.year()}`);
              }
            }
          }

          const quarterStr = `Q${Math.floor(date.month() / 3) + 1}-${date.year()}`;
          const quarterKey = `EXPENSE_FORECAST::${quarterStr}`;

          if (!bd[quarterKey]) {
            if (obj[quarterKey]) {
              obj[quarterKey] += <number>bd[key];
            } else {
              obj[quarterKey] = <number>bd[key];

              if (!forecast_header?.date_headers.find((h: string) => h === quarterStr)) {
                forecast_header?.date_headers.push(
                  `Q${Math.floor(date.month() / 3) + 1}-${date.year()}`
                );
              }
            }
          }
        });
      const desc = Object.getOwnPropertyDescriptor(forecast_header, 'date_headers');

      if (desc?.writable) {
        forecast_header?.date_headers.sort(this.periodSortingFunction);
      }

      Object.keys(bd)
        .filter(
          (key) =>
            key.startsWith('EXPENSE_WP::') &&
            key !== 'EXPENSE_WP::TO_DATE' &&
            !key.endsWith('::SNAPSHOT')
        )
        .forEach((key) => {
          const value = <number>bd[key];
          const splitkey = key.split('::');
          const date = dayjs(`01/${splitkey[1].replace('-', '/')}`);

          if (isNaN(date.year())) {
            return;
          }

          // YTD - Actuals
          const year_key = `EXPENSE_WP::${date.year()}`;

          if (!bd[year_key]) {
            if (obj[year_key]) {
              obj[year_key] += value;
            } else {
              obj[year_key] = value;
            }

            if (!historical_header?.date_headers.find((h: string) => h === `${date.year()}`)) {
              historical_header?.date_headers.push(`${date.year()}`);
            }
          }

          // this part is for the calculation of the quarter which includes the month of the auxilius start date
          let keysOfMonthsBeforeAuxStart: string[] = [];

          if (auxilius_start_date) {
            keysOfMonthsBeforeAuxStart =
              this.budgetGridService.getMonthsBeforeAuxiliusStartForQuarterCalc(
                auxilius_start_date
              );
          }

          if (keysOfMonthsBeforeAuxStart.includes(key)) {
            return;
          }

          // QTD Actuals
          const quarter_str = `Q${Math.floor(date.month() / 3) + 1}-${date.year()}`;
          const quarter_key = `EXPENSE_WP::${quarter_str}`;

          if (!bd[quarter_key]) {
            if (obj[quarter_key]) {
              obj[quarter_key] += value;
            } else {
              obj[quarter_key] = value;

              if (!historical_header?.date_headers.find((h: string) => h === quarter_str)) {
                historical_header?.date_headers.push(quarter_str);
              }
            }
          }

          const forecast_quarter_key = `EXPENSE_FORECAST::${splitkey[1]}`;
          const plan = <number>bd[forecast_quarter_key] || 0;
          const var_cost = value - plan;

          if (!bd[`EXPENSE_WP::${splitkey[1]}::VAR_COST`]) {
            obj[`EXPENSE_WP::${splitkey[1]}::VAR_COST`] = var_cost;
          }

          if (!bd[`EXPENSE_WP::${splitkey[1]}::VAR_PERC`]) {
            obj[`EXPENSE_WP::${splitkey[1]}::VAR_PERC`] =
              isNaN(var_cost / plan) || !plan ? 0 : var_cost / plan;
          }

          const plan_quarter = <number>bd[`EXPENSE_FORECAST::Q${quarter_str}::`];
          const var_cost_quarter = obj[quarter_key] - plan_quarter;

          if (!bd[`EXPENSE_WP::Q${quarter_str}::VAR_COST`]) {
            obj[`EXPENSE_WP::Q${quarter_str}::VAR_COST`] = var_cost_quarter;
          }

          if (!bd[`EXPENSE_WP::Q${quarter_str}::VAR_PERC`]) {
            obj[`EXPENSE_WP::Q${quarter_str}::VAR_PERC`] =
              isNaN(var_cost_quarter / plan_quarter) || !plan_quarter
                ? 0
                : var_cost_quarter / plan_quarter;
          }

          const plan_year = <number>bd[`EXPENSE_FORECAST::${date.year}::`];
          const var_cost_year = obj[year_key] - plan_quarter;

          obj[`EXPENSE_WP::${date.year()}::VAR_COST`] = var_cost_year;
          obj[`EXPENSE_WP::${date.year()}::VAR_PERC`] =
            isNaN(var_cost_year / plan_year) || !plan_year ? 0 : var_cost_year / plan_year;
        });

      const setDataForHiddenColumn = (
        selector: string,
        callback: (date: dayjs.Dayjs, key: string) => void
      ) => {
        Object.keys(bd)
          .filter((key) => key.endsWith(selector) && !key.startsWith('TO_DATE::'))
          .forEach((key) => {
            const splitkey = key.split('::');
            const date = dayjs(`01/${splitkey[0].replace('-', '/')}`);

            if (Number.isNaN(date.year())) {
              return;
            }

            callback(date, key);
          });
      };

      setDataForHiddenColumn('::PLAN', (date: dayjs.Dayjs, key: string) => {
        const planKey = `${date.year()}::PLAN`;

        obj[planKey] = (obj[planKey] || 0) + <number>bd[key];
      });

      setDataForHiddenColumn('::VAR_COST', (date: dayjs.Dayjs) => {
        const planKey = `${date.year()}::PLAN`;
        const varCostKey = `${date.year()}::VAR_COST`;

        const actuals = obj[`EXPENSE_WP::${date.year()}`] || 0;

        obj[`${varCostKey}`] = actuals - obj[planKey];
      });

      setDataForHiddenColumn('::VAR_PERC', (date: dayjs.Dayjs) => {
        const planKey = `${date.year()}::PLAN`;
        const varPercKey = `${date.year()}::VAR_PERC`;

        const varCost = obj[`${date.year()}::VAR_COST`] || 0;

        obj[`${varPercKey}`] = this.getVarPerc(varCost, obj[planKey]);
      });

      // Fill data for quarters
      Object.keys({ ...obj })
        .filter((key) => key.startsWith('EXPENSE_WP::Q'))
        .forEach((key) => {
          const [quarter] = key.match(/Q\d-\d{4}$/) || [];

          if (!quarter) {
            return;
          }

          const quarterNumber = +quarter[1];

          const [quarterYear] = quarter.match(/\d{4}$/) || [];

          if (!quarterYear) {
            return;
          }

          const plan = Object.keys({ ...bd })
            .filter((field) => field.match(new RegExp(`-${quarterYear}::PLAN`)))
            .filter((field) => dayjs(field.replace('::PLAN', '')).quarter() === quarterNumber)
            .reduce((sum, planKey) => {
              return sum + <number>bd[planKey];
            }, 0);

          const quarter_key = `EXPENSE_WP::${quarter}`;
          const planKey = `${quarter}::PLAN`;
          const varCostKey = `${quarter}::VAR_COST`;
          const varPerc = `${quarter}::VAR_PERC`;

          const varCost = this.getVarCost(obj[quarter_key], plan);

          obj[planKey] = plan;
          obj[varCostKey] = varCost;
          obj[varPerc] = this.getVarPerc(varCost, plan);
        });

      const h_desc = Object.getOwnPropertyDescriptor(historical_header, 'date_headers');

      if (h_desc?.writable) {
        historical_header?.date_headers.sort(this.periodSortingFunction);
      }

      const extraAttributes = Array.isArray(bd.attributes)
        ? bd.attributes.reduce(
            (acc, a) => {
              if (a.attribute_name && a.attribute_value) {
                acc[getEncodedAttributeName(a.attribute_name)] = a.attribute_value;
              }

              return acc;
            },
            {} as Record<string, string>
          )
        : {};

      return { ...bd, ...obj, ...extraAttributes };
    });
    const headers: RequireSome<BudgetHeader, 'date_headers'>[] = Object.assign(remaining_header, [
      historical_header,
      forecast_header,
    ]);

    return [bud_data, headers] as const;
  }

  private budgetExportColumnIDs() {
    let colIds = [] as string[];

    (this.gridAPI?.getColumnDefs() || []).forEach((columnDef) =>
      colIds.push(...this.getColumnIds(columnDef))
    );
    colIds = colIds.filter(
      (ci) =>
        ci !== 'group1' &&
        ci !== 'group2' &&
        ci !== 'group3' &&
        ci !== 'group4' &&
        ci !== 'group5' &&
        isNaN(Number(ci)) // Filter spacing rows
    );

    return colIds;
  }

  chartLegendClick(isCurrent = false) {
    this.isSnapShotSelected$.next({
      currentLegend: isCurrent
        ? !this.isSnapShotSelected$.getValue().currentLegend
        : this.isSnapShotSelected$.getValue().currentLegend,
      selected: this.isSnapShotSelected$.getValue().selected,
      snapShotLegend: isCurrent
        ? this.isSnapShotSelected$.getValue().snapShotLegend
        : !this.isSnapShotSelected$.getValue().snapShotLegend,
    });
    const data = this.canvasDatasets$.getValue().map((x, index) => {
      if (index === 0 || index === 1 || index === 2) {
        return { ...x, hidden: !this.isSnapShotSelected$.getValue().currentLegend };
      }

      return { ...x, hidden: !this.isSnapShotSelected$.getValue().snapShotLegend };
    });

    this.canvasDatasets$.next(data);
  }

  closeCustomList() {
    this.isCustomOpen = false;
  }

  closeList() {
    this.isYearsOpen = false;
  }

  compareDropdownChange(value: string) {
    this.compareToValue = value;
    this.HeaderDropdownService.resetGroupColumnChanges();

    if (value === null) {
      this.refreshGrid$.next(true);
    }
  }

  constructor() {
    this.budgetStore.setLoading(true);

    this.setUserPermissions();

    this.selectedVendor.valueChanges.pipe(takeUntilDestroyed()).subscribe((v) => {
      if (v) {
        this.activitiesModal.vendor_id.set(v);
      }

      localStorage.setItem('selectedVendor', v || '');
      this.cdr.markForCheck();
      this.gridAPI?.deselectAll();
      this.onSelect();
    });

    effect(() => {
      const isProcessing = this.eventQuery.selectProcessingEvent(
        EventType.INLINE_EDIT_BUDGET_ACTIVITIES
      )();

      const isBudgetUploadProcessing = this.eventQuery.selectProcessingEvent(
        EventType.BUDGET_TEMPLATE_UPLOADED
      )();

      if (isProcessing === false || isBudgetUploadProcessing === false) {
        this.activitiesModal.refreshCategories();
        this.refreshGrid$.next(true);
      }
    });

    this.vendorCurrencyEnabled$ = this.launchDarklyService.select$((flags) => {
      return flags.vendor_currency;
    });

    this.snapshotService.getSnapshotList().pipe(takeUntilDestroyed()).subscribe();

    this.compareToValue = undefined;

    this.gqlService
      .getTrialPreference$(TrialPreferenceType.BUDGET_GRID_YEARS)
      .pipe(
        takeUntilDestroyed(),
        distinctUntilChanged(isEqual),
        tap((prefBudgetGridYears) => {
          this.budgetGridYears = prefBudgetGridYears?.data?.value
            ? (JSON.parse(prefBudgetGridYears?.data?.value) as Array<number>)
            : null;
        }),
        switchMap(() => {
          this.selectedCustom$.next('');

          return this.listCustomUserView();
        })
      )
      .subscribe();

    this.budgetQuery
      .selectLoading()
      .pipe(takeUntilDestroyed())
      .subscribe((loading) => {
        if (!loading) {
          this.loadBudgetGridData();
        }
      });

    combineLatest([this.mainQuery.select('trialKey'), this.gridAPI$.pipe(take(1), startWith(null))])
      .pipe(
        switchMap(() => this.launchDarklyService.select$((flags) => flags.budget_unit_of_measure))
      )
      .pipe(takeUntilDestroyed())
      .subscribe((bool) => {
        uomHide$.next(!bool);

        if (this.gridAPI) {
          AgSetColumnsVisible({
            gridApi: this.gridAPI,
            keys: ['uom'],
            visible: bool,
          });
        }
      });

    this.showAnalyticsSection$ = this.launchDarklyService.select$(
      (flags) => flags.section_budget_analytics
    );

    this.showBudgetTypeSelect$ = this.launchDarklyService.select$(
      (flags) => flags.section_budget_type
    );

    this.showAnalyticsSection$
      .pipe(
        switchMap((flag) => {
          if (flag) {
            this.pendingChangesLoading.next(true);
            this.wpLoading.next(true);
            this.invoicesTotalLoading.next(true);

            return rxMerge(
              this.budgetService.getPendingChanges().pipe(
                tap(() => {
                  this.pendingChangesLoading.next(false);
                })
              ),
              this.budgetService.getBudgetWorkPerformed().pipe(
                tap(() => {
                  this.wpLoading.next(false);
                })
              ),
              this.budgetService.getInvoicesTotal().pipe(
                tap(() => {
                  this.invoicesTotalLoading.next(false);
                })
              )
            );
          }

          return EMPTY;
        }),
        takeUntilDestroyed()
      )
      .subscribe();

    // reset any older selected vendors.
    this.organizationStore.setActive(null);

    this.listCustomUserView().catch(console.error);

    this.authService
      .isAuthorized$({
        permissions: [PermissionType.PERMISSION_EDIT_BUDGET],
        sysAdminsOnly: false,
      })
      .pipe(takeUntilDestroyed())
      .subscribe((x) => {
        this.userHasEditPermissions = x;
      });
  }

  private currentQuarter(current_period: string): string {
    const date = this.parseBudgetMonthToDate(current_period);

    return `Q${Math.floor(date.month() / 3) + 1}-${date.year()}`;
  }

  private currentYear(current_period: string): string {
    return `${this.parseBudgetMonthToDate(current_period).year()}`;
  }

  customChanges(item: Omit<UserCustomView, '__typename' | 'id' | 'is_custom'>) {
    const index = this.highlightedCustom.getValue();

    if (index != null || item) {
      if (this.selectedCustom$.getValue() !== item.name) {
        this.selectedCustom$.next(item.name);
        this.gridData$.next([]);
        this.gridAPI?.showLoadingOverlay();
        const customValues = this.customValues$.getValue();
        const selectedIndex = customValues?.findIndex((x) => x.name === item.name) ?? -1;

        if (customValues && selectedIndex !== -1) {
          const selData = customValues[selectedIndex];
          const activeTrial = this.mainQuery.getSelectedTrial()?.id;

          try {
            const localItem = localStorage.getItem(`customView`) || '{}';

            if (activeTrial) {
              const letItem = { ...JSON.parse(localItem) };

              letItem[activeTrial] = { id: selData.id, name: selData.name };
              localStorage.setItem(`customView`, JSON.stringify(letItem));
            }
          } catch (e) {
            console.error(e);
          }

          this.selectedCustomIndex = selectedIndex;
          const visCol = JSON.parse(JSON.parse(selData?.metadata));

          if (Object.prototype.hasOwnProperty.call(visCol, 'overall_budget')) {
            this.visibleColumns = visCol;
            this.gridAPI?.showLoadingOverlay();
            setTimeout(() => {
              this.loadBudgetGridData(true);
              setTimeout(() => {
                this.gridAPI?.hideOverlay();
              }, 500);
            }, 0);
          }
        }
      } else {
        this.selectedCustomIndex = index;
      }
    }

    this.closeCustomList();
    this.gridAPI?.hideOverlay();
  }

  private defaultChooserSelection(
    data: (UserCustomView & {
      showLine: boolean;
    })[]
  ) {
    const indexV = data.findIndex((x) => x.name === 'Monthly');

    if (indexV !== -1) {
      this.selectedCustom$.next(data[indexV].name);
      this.visibleColumns = JSON.parse(JSON.parse(data[indexV].metadata));
      this.highlightedCustom.next(indexV);
      this.selectedCustomIndex = indexV;
    } else {
      this.selectedCustom$.next(data[0].name);
      this.visibleColumns = JSON.parse(JSON.parse(data[0].metadata));
      this.highlightedCustom.next(0);
      this.selectedCustomIndex = 0;
    }
  }

  async editCustom(item: UserCustomView & { showLine: boolean }) {
    const overlay = await firstValueFrom(
      this.overlayService.openPopup<
        { columns?: VisibleColumns },
        VisibleColumns,
        ColumnChooserLegacyComponent
      >({
        content: ColumnChooserLegacyComponent,
        data: { columns: JSON.parse(JSON.parse(item.metadata)) },
        settings: {
          header: 'Customize Vendor Budget View',
          primaryButton: {
            action: (instance) => instance?.onConfirm(),
            label: 'Confirm',
          },
        },
      }).afterClosed$
    );

    const resp = this.overlayService.openPopup<
      unknown,
      { label?: string },
      BudgetCustomUpdateComponent
    >({
      content: BudgetCustomUpdateComponent,
      data: {
        textName: item.name,
      },
      settings: {
        header: 'Name Custom View',
        primaryButton: {
          action: (instance) => instance?.saveText(),
          label: 'Confirm',
        },
      },
    });
    const event = await firstValueFrom(resp.afterClosed$);

    if (event.data?.label && overlay.data) {
      const flag = await this.budgetService.updateUserCustomView({
        id: item.id,
        metadata: JSON.stringify(overlay.data),
        name: event.data.label,
      } as UpdateUserCustomViewInput);

      if (flag) {
        await this.listCustomUserView();
        this.customChanges({ ...item, name: event.data.label });
        setTimeout(() => {
          this.loadBudgetGridData(true);
        }, 0);
        this.overlayService.success();
      }
    }
  }

  findFirstExpenseForecastColId(
    columns: Array<ColDef | ColGroupDef> | undefined
  ): string | undefined {
    if (!columns) {
      return undefined;
    }

    for (const column of columns) {
      if ('colId' in column && column.colId && column.colId.includes('EXPENSE_FORECAST')) {
        return column.colId;
      } else if (this.isColGroupDef(column) && column.children) {
        const colId = this.findFirstExpenseForecastColId(column.children);

        if (colId) {
          return colId;
        }
      }
    }

    return undefined;
  }

  private getCategoryPreviousFullPath(
    category: BeInlineCategoryDropdownOption,
    trialVendorPath: string
  ): string {
    const originalCategory = this.activitiesModal
      .categories()
      ?.find((origCategory) => origCategory.id === category.id);

    return originalCategory ? `${trialVendorPath}${originalCategory.fullPath}` : '';
  }

  private getColumnIds(def: ColDef | ColGroupDef) {
    const colIds = [] as string[];
    let str = '';
    const disallowed_types = ['EXPENSE_WP::TO_DATE'];

    if (this.isColDef(def)) {
      str = def.colId || '';

      if (disallowed_types.indexOf(str) === -1) {
        colIds.push(str);
      }
    }

    if ((def as ColGroupDef).children !== undefined && disallowed_types.indexOf(str) === -1) {
      (def as ColGroupDef).children.forEach((child) => {
        if (!this.isColDef(child) || !child.hide) {
          colIds.push(...this.getColumnIds(child));
        }
      });
    }

    return colIds;
  }

  private getCurrentPeriodView(currentPeriod: string[]) {
    return currentPeriod
      .filter((period) =>
        period.startsWith('Q')
          ? this.visibleColumns.current_period.quarters
          : this.visibleColumns.current_period.months
      )
      .map<ColDef | ColGroupDef>((child) => {
        let cHeaderName: string;

        if (child.startsWith('Q')) {
          cHeaderName = child.split('-').join(' ');
        } else {
          cHeaderName = `${Utils.SHORT_MONTH_NAMES[this.parseBudgetMonthToDate(child).month()]} ${
            child.split('-')[1]
          }`;
        }

        const columnParams = this.compareToValue
          ? {
              headerGroupComponent: AgHeaderDropdownComponent,
              headerGroupComponentParams: {
                toggleCb: this.HeaderDropdownService.registerGroupColumnChange.bind(
                  this.HeaderDropdownService
                ),
              },
            }
          : {};

        return {
          ...columnParams,
          children: this.getForecastSubColumns(child, !!this.compareToValue),
          colId: 'currentPeriod',
          headerClass: [
            this.compareToValue
              ? 'flex items-center justify-center future'
              : 'ag-header-align-center future',
          ],
          headerName: cHeaderName,
        };
      });
  }

  private getDiscountAmountForCanvas({
    amtType,
    amtTypeIndex,
    datasets,
    loopIndex,
    periodIndex,
    selectedPeriod,
  }: {
    amtType: string;
    amtTypeIndex: number;
    datasets: ChartDataset<'bar', BudgetChartData>[];
    loopIndex: number;
    periodIndex: number;
    selectedPeriod: PeriodType;
  }) {
    let discountAmount = 0;

    if (amtType === 'Services') {
      if (selectedPeriod === PeriodType.PERIOD_MONTH) {
        discountAmount = datasets[amtTypeIndex].data[periodIndex].discountData;
      }

      if (loopIndex % 3 === 0 && selectedPeriod === PeriodType.PERIOD_QUARTER) {
        discountAmount = datasets[amtTypeIndex].data[periodIndex].discountData;
      }

      /*
      let's say the timeline is Jan 2022 to Oct 2023, loopIndex will go from 0 to 21 (12 + 9) for each month in the years,
      and if the selectedPeriod is PERIOD_YEAR then periodIndex will go from 0 to 1 for each year.
      So in this case datasets[amtTypeIndex].discountData will have two values (one for each year).
      When loopIndex is 0, we'll return the first value in discountData, and when loopIndex is 12, we'll return the second.
    */
      if (loopIndex % 12 === 0 && selectedPeriod === PeriodType.PERIOD_YEAR) {
        discountAmount = datasets[amtTypeIndex].data[periodIndex].discountData;
      }
    }

    return discountAmount;
  }

  /*
    The purpose of this method is to group up the monthly discount data in monthlyData and return one discount value for each xAxisPeriodLabels.
    For example, if selectedPeriod was QUARTER and trial timeline is Jan 2022 to Oct 2023, then xAxisPeriodLabels would have Q1 2022, Q2 2022 ... Q4 2023,
    so this method would return an array with 8 elements.
  */
  private getDiscountDataForCanvas(
    xAxisPeriodLabels: string[],
    selectedPeriod: PeriodType,
    monthlyData: Dictionary<ExtendedBudgetData[]>,
    isSnapshot: boolean
  ): number[] {
    const snapshot = isSnapshot ? '::SNAPSHOT' : '';

    return xAxisPeriodLabels.map((periodLabel) => {
      if (selectedPeriod === PeriodType.PERIOD_QUARTER) {
        const [quarter, year] = periodLabel.split(' ');
        const quarterNumber = parseInt(quarter.replace('Q', ''));
        const startDate = dayjs().year(parseInt(year)).quarter(quarterNumber).startOf('quarter');
        let totalSum = 0;

        // Iterate through all 3 months of the quarter
        for (let i = 0; i < 3; i++) {
          const month = startDate.add(i, 'month').format('MMM-YYYY').toUpperCase();
          const wpKey = `EXPENSE_WP_USD::${month}${snapshot}`;
          const forecastKey = `EXPENSE_FORECAST_USD::${month}${snapshot}`;

          totalSum +=
            sumBy(monthlyData.Discount, wpKey) || sumBy(monthlyData.Discount, forecastKey) || 0;
        }

        return totalSum;
      }

      if (selectedPeriod === PeriodType.PERIOD_YEAR) {
        const year = parseInt(periodLabel, 10);

        const startDate = dayjs().year(year).startOf('year');

        let totalSum = 0;

        for (let i = 0; i < 12; i++) {
          // Iterate through all 12 months of the year
          const month = startDate.add(i, 'month').format('MMM-YYYY').toUpperCase();
          const wpKey = `EXPENSE_WP_USD::${month}${snapshot}`;
          const forecastKey = `EXPENSE_FORECAST_USD::${month}${snapshot}`;

          totalSum +=
            sumBy(monthlyData.Discount, wpKey) || sumBy(monthlyData.Discount, forecastKey) || 0;
        }

        return totalSum;
      }

      return (
        sumBy(monthlyData.Discount, `EXPENSE_WP_USD::${periodLabel}${snapshot}`) ||
        sumBy(monthlyData.Discount, `EXPENSE_FORECAST_USD::${periodLabel}${snapshot}`) ||
        0
      );
    });
  }

  private getForecastSubColumns(
    forecastMonth: string,
    expandHiddenColumns: boolean
  ): (ColDef | ColGroupDef)[] {
    return [
      {
        aggFunc: 'sum',
        cellClass: (p) => [
          getCellClass(this.selectedBudgetCurrencyType$.getValue())(p),
          AuxExcelStyleKeys.BORDER_LEFT,
          !expandHiddenColumns ? AuxExcelStyleKeys.BORDER_RIGHT : '',
        ],
        field: `EXPENSE_FORECAST::${forecastMonth}`,
        headerClass: [
          'ag-header-align-center',
          AuxExcelStyleKeys.BORDER_LEFT,
          !expandHiddenColumns ? AuxExcelStyleKeys.BORDER_RIGHT : '',
        ],
        headerName: 'Forecast',
        hide: false,
        minWidth: CellSize.xLarge,
        valueFormatter: agBudgetCurrencyFormatter(this.selectedBudgetCurrencyType$.getValue()),
        width: CellSize.xLarge,
      },
      {
        ...TableConstants.dynamicColumnProps(this.compareToValue || ''),
        aggFunc: 'sum',
        cellClass: getCellClass(this.selectedBudgetCurrencyType$.getValue()),
        field: `EXPENSE_FORECAST::${forecastMonth}::SNAPSHOT`,
        hide: !expandHiddenColumns,
        minWidth: CellSize.xLarge,
        valueFormatter: agBudgetCurrencyFormatter(this.selectedBudgetCurrencyType$.getValue()),
      },
      {
        aggFunc: 'sum',
        cellClass: getCellClass(this.selectedBudgetCurrencyType$.getValue()),
        cellRenderer: VariationStatusComponent,
        field: `EXPENSE_FORECAST::${forecastMonth}::VAR_COST::SNAPSHOT`,
        headerClass: 'ag-header-align-center',
        headerName: 'Var ($)',
        hide: !expandHiddenColumns,
        minWidth: CellSize.xLarge,
        valueFormatter: agBudgetCurrencyFormatter(this.selectedBudgetCurrencyType$.getValue()),
        width: CellSize.xLarge,
      },
      {
        cellClass: [
          'ag-cell-align-right',
          'budget-percent',
          expandHiddenColumns ? AuxExcelStyleKeys.BORDER_RIGHT : '',
        ],
        cellRenderer: VariationStatusComponent,
        field: `EXPENSE_FORECAST::${forecastMonth}::VAR_PERC::SNAPSHOT`,
        headerClass: [
          'ag-header-align-center',
          expandHiddenColumns ? AuxExcelStyleKeys.BORDER_RIGHT : '',
        ],
        headerName: 'Var (%)',
        hide: !expandHiddenColumns,
        minWidth: CellSize.large,
        valueFormatter: (params: ValueFormatterParams) =>
          Utils.percentageFormatter(
            Math.abs(
              this.getVarSnapshotPercent(
                `EXPENSE_FORECAST::${forecastMonth}::SNAPSHOT`,
                `EXPENSE_FORECAST::${forecastMonth}::VAR_COST::SNAPSHOT`,
                `EXPENSE_FORECAST::${forecastMonth}::VAR_PERC::SNAPSHOT`
              )(params)
            )
          ),
        valueGetter: this.getVarSnapshotPercent(
          `EXPENSE_FORECAST::${forecastMonth}::SNAPSHOT`,
          `EXPENSE_FORECAST::${forecastMonth}::VAR_COST::SNAPSHOT`,
          `EXPENSE_FORECAST::${forecastMonth}::VAR_PERC::SNAPSHOT`
        ),
        width: CellSize.large,
      },
    ];
  }

  private getVarCost(actuals: number, plan: number): number {
    return actuals - plan;
  }

  private getVarPerc(varCost: number, plan: number): number {
    return plan ? round(varCost / plan, 2) : 0;
  }

  getVarSnapshotPercent =
    (snapshotActualsKey: string, varCostKey: string, percentKey: string) =>
    (params: ValueFormatterParams | ValueGetterParams) => {
      let percent = (params.data || {})[percentKey] || 0;

      if (params.node?.aggData) {
        const { aggData } = params.node;

        const actuals = aggData[snapshotActualsKey];

        if (!actuals) {
          return percent;
        }

        percent = decimalDivide(aggData[varCostKey], actuals, 2);
      }

      return percent;
    };

  highlightCustom(index: number): void {
    this.highlightedCustom.next(index);
  }

  private isAllChildrenHiddenInHeaderGroup(column: ColDef | ColGroupDef): boolean {
    if (Object.prototype.hasOwnProperty.call(column, 'children')) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return column.children.every((col) => col.hide === true);
    }

    return false;
  }

  private isColDef(col: ColDef | ColGroupDef): col is ColDef {
    return (col as ColDef).colId !== undefined;
  }

  private isColGroupDef(column: ColDef | ColGroupDef): column is ColGroupDef {
    return 'children' in column;
  }

  private isColumnHasStyleClass(colId: string, className: string): boolean {
    const headerClass = this.gridAPI?.getColumn(colId)?.getColDef().headerClass;

    if (headerClass) {
      if (isArray(headerClass)) {
        return headerClass.includes(className);
      }

      if (headerClass === className) {
        return true;
      }
    }

    return false;
  }

  private isSpacerColumn(column: ColDef | ColGroupDef): boolean {
    if (Object.prototype.hasOwnProperty.call(column, 'colId')) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return column.colId === 'spacerColumn';
    }

    return false;
  }

  private async listCustomUserView() {
    const data = (await this.budgetService.listUserCustomView()) as (UserCustomView & {
      showLine: boolean;
    })[];

    if (data) {
      this.customValues$.next([]);
      const sortingForDefault = this.sortingForDefault(data);
      const sortData = sortingForDefault.sort((x, y) => {
        if (x.is_custom && y.is_custom) {
          return Utils.alphaNumSort(x.name.toUpperCase(), y.name.toUpperCase());
        }

        return 0;
      });

      this.customValues$.next(sortData);
      try {
        const activeTrial = this.mainQuery.getSelectedTrial()?.id;
        const localItem = localStorage.getItem(`customView`);
        const localView = localItem && JSON.parse(localItem);

        if (localView && activeTrial && localView[activeTrial]) {
          const localIndex = sortData.findIndex((x) => x.name === localView[activeTrial].name);

          if (localIndex !== -1) {
            this.highlightedCustom.next(localIndex);
            this.selectedCustomIndex = localIndex;
            this.selectedCustom$.next(sortData[localIndex].name);
            this.visibleColumns = JSON.parse(JSON.parse(sortData[localIndex].metadata));
          } else {
            if (localItem != null) {
              const remItem = JSON.parse(localItem);

              delete remItem[activeTrial];
              localStorage.setItem(`customView`, JSON.stringify(remItem));
            }

            this.defaultChooserSelection(sortData);
          }
        } else {
          this.defaultChooserSelection(sortData);
        }
      } catch {
        this.defaultChooserSelection(sortData);
      }
    }
  }

  private loadBudgetGridData(refresh = false) {
    this.gridAPI = undefined;
    this.showGrid$.next(false);
    const { budget_data, header_data } = this.budgetQuery.getValue();

    const auxilius_start_date = this.mainQuery.getAuxiliusStartDate();
    const activeOrganizationId = this.selectedVendorSignal();
    const [aggregated_budget_data, aggregated_header_data] = this.aggregateQuartersAndYears(
      (activeOrganizationId
        ? budget_data?.filter((bd) => bd.vendor_id === activeOrganizationId)
        : budget_data) || [],
      header_data
    );

    const attributes = getAttributeColumns({
      attributes: budget_data.map((z) => z.attributes || []),
    });

    const defs: (ColDef | ColGroupDef)[] = [];

    const attr = attributeColumnDef(attributes, BEAttributesLSKey, budget_data, true);

    this.budgetQueryData.set(budget_data);

    defs.push(attr);

    defs.push(TableConstants.SPACER_COLUMN);

    defs.push(
      overallBudgetColumnDef(
        this.visibleColumns.overall_budget,
        this.selectedBudgetCurrencyType$.getValue(),
        this.compareToValue
      )
    );

    const el = (aggregated_header_data as RequireSome<BudgetHeader, 'date_headers'>[]).find(
      (x) => x.group_name === 'Work Performed'
    );
    const forecastHeader = (
      aggregated_header_data as RequireSome<BudgetHeader, 'date_headers'>[]
    ).find((x) => x.group_name === 'Forecast');

    if (!refresh) {
      const hYears = (el?.date_headers || []).reduce((acc: number[], col_header) => {
        const headerName = col_header.split('-').pop();

        if (headerName !== '' && !acc.includes(Number(headerName))) {
          acc.push(Number(headerName));
        }

        return acc;
      }, []);

      if (Array.isArray(this.budgetGridYears)) {
        this.years = hYears.map((year) => {
          return { enabled: !!this.budgetGridYears?.includes(year), label: year };
        });
      } else {
        this.years = hYears.map((year, index) => ({
          enabled: auxilius_start_date ? true : index === hYears.length - 1,
          label: year,
        }));
      }

      this.setSelectedYear();
    }

    if (el) {
      let actualsColDefs: (ColDef | ColGroupDef)[] = el.date_headers
        .filter((col_header) => {
          const year = col_header.split('-').pop();
          const enabled = this.years.find((h) => h.label === Number(year))?.enabled;

          if (!forecastHeader) {
            return enabled;
          }

          const currentForecast = forecastHeader.date_headers[0];

          return (
            enabled &&
            col_header !== this.currentQuarter(currentForecast) &&
            col_header !== this.currentYear(currentForecast)
          );
        })
        .filter((col_header) => {
          if (!isNaN(Number(col_header))) {
            return this.visibleColumns.historicals.years;
          }

          if (col_header.startsWith('Q')) {
            return this.visibleColumns.historicals.quarters;
          }

          return this.visibleColumns.historicals.months;
        })
        .map((col_header) => {
          let headerName: string;

          if (col_header.startsWith('Q')) {
            headerName = col_header.replace('-', ' ');
          } else if (!isNaN(Number(col_header))) {
            headerName = col_header;
          } else {
            const date = this.parseBudgetMonthToDate(col_header);

            headerName = `${Utils.SHORT_MONTH_NAMES[date.month()]} ${date.year()}`;
          }

          const fieldNamePrefix = this.compareToValue ? '::SNAPSHOT' : '';
          const filedNameAffix = this.compareToValue ? 'EXPENSE_WP::' : '';

          const snapshotColumnParams = this.compareToValue
            ? {
                headerGroupComponent: AgHeaderDropdownComponent,
                headerGroupComponentParams: {
                  toggleCb: this.HeaderDropdownService.registerGroupColumnChange.bind(
                    this.HeaderDropdownService
                  ),
                },
              }
            : {};

          return {
            ...snapshotColumnParams,
            children: [
              {
                aggFunc: 'sum',
                cellClass: (p: CellClassParams) => [
                  getCellClass(this.selectedBudgetCurrencyType$.getValue())(p),
                  AuxExcelStyleKeys.BORDER_LEFT,
                  this.compareToValue ? '' : AuxExcelStyleKeys.BORDER_RIGHT,
                ],
                field: `${el.expense_type}::${col_header}`,
                headerClass: [
                  'ag-header-align-center',
                  AuxExcelStyleKeys.BORDER_LEFT,
                  this.compareToValue ? '' : AuxExcelStyleKeys.BORDER_RIGHT,
                ],
                headerName: 'Actuals',
                hide: false,
                minWidth: CellSize.xLarge,
                valueFormatter: agBudgetCurrencyFormatter(
                  this.selectedBudgetCurrencyType$.getValue()
                ),
                width: CellSize.xLarge,
              },
              {
                ...TableConstants.dynamicColumnProps(this.compareToValue || 'Plan'),
                aggFunc: 'sum',
                cellClass: getCellClass(this.selectedBudgetCurrencyType$.getValue()),
                field: this.compareToValue
                  ? `${el.expense_type}::${col_header}::SNAPSHOT`
                  : `${col_header}::PLAN`,
                hide: !this.compareToValue,
                minWidth: CellSize.xLarge,
                valueFormatter: agBudgetCurrencyFormatter(
                  this.selectedBudgetCurrencyType$.getValue()
                ),
              },
              {
                aggFunc: 'sum',
                cellClass: getCellClass(this.selectedBudgetCurrencyType$.getValue()),
                cellRenderer: VariationStatusComponent,
                field: `${filedNameAffix}${col_header}::VAR_COST${fieldNamePrefix}`,
                headerClass: 'ag-header-align-center',
                headerName: 'Var ($)',
                hide: !this.compareToValue,
                minWidth: CellSize.xLarge,
                valueFormatter: agBudgetCurrencyFormatter(
                  this.selectedBudgetCurrencyType$.getValue()
                ),
                width: CellSize.xLarge,
              },
              {
                cellClass: [
                  'ag-cell-align-right',
                  'budget-percent',
                  AuxExcelStyleKeys.BORDER_RIGHT,
                ],
                cellRenderer: VariationStatusComponent,
                field: `${filedNameAffix}${col_header}::VAR_PERC${fieldNamePrefix}`,
                headerClass: ['ag-header-align-center', AuxExcelStyleKeys.BORDER_RIGHT],
                headerName: 'Var (%)',
                hide: !this.compareToValue,
                minWidth: CellSize.large,
                valueFormatter: (params: ValueFormatterParams) =>
                  Utils.percentageFormatter(
                    Math.abs(
                      this.getVarSnapshotPercent(
                        `${el.expense_type}::${col_header}::SNAPSHOT`,
                        `${filedNameAffix}${col_header}::VAR_COST${fieldNamePrefix}`,
                        `${filedNameAffix}${col_header}::VAR_PERC${fieldNamePrefix}`
                      )(params)
                    )
                  ),
                valueGetter: this.getVarSnapshotPercent(
                  `${el.expense_type}::${col_header}::SNAPSHOT`,
                  `${filedNameAffix}${col_header}::VAR_COST${fieldNamePrefix}`,
                  `${filedNameAffix}${col_header}::VAR_PERC${fieldNamePrefix}`
                ),
                width: CellSize.large,
              },
            ].filter((col) => (this.compareToValue ? true : col.headerName === 'Actuals')),
            headerClass: 'ag-header-align-center justify-center',
            headerName,
          } as ColGroupDef;
        });

      if (
        auxilius_start_date &&
        (this.visibleColumns.historicals.months || this.visibleColumns.historicals.quarters)
      ) {
        actualsColDefs = [
          {
            children: [
              {
                aggFunc: 'sum',
                cellClass: getCellClass(this.selectedBudgetCurrencyType$.getValue()),
                field: 'trial_to_date',
                headerClass: 'ag-header-align-center',
                headerName: 'Auxilius Start',
                valueFormatter: agBudgetCurrencyFormatter(
                  this.selectedBudgetCurrencyType$.getValue()
                ),
              },
            ],
            colId: 'auxilius_start',
            headerClass: ['ag-header-align-center bg-aux-blue-dark aux-white border-aux-blue-dark'],
            headerName: '',
          },
          TableConstants.SPACER_COLUMN,
          ...actualsColDefs.filter((col) => {
            if (col.headerName?.startsWith('Q')) {
              const [month, year] = col.headerName?.split(' ') || [];
              const monthStr = `${+month.replace('Q', '') * 3}`.padStart(2, '0');

              return dayjs(new Date(`${monthStr}/01/${year}`)).isSameOrAfter(
                dayjs(auxilius_start_date).date(1),
                'month'
              );
            }

            if (!Number.isNaN(Number(col.headerName))) {
              return true;
            }

            return dayjs(
              new Date(`01/${col.headerName?.toUpperCase().replace(' ', '/')}`)
            ).isSameOrAfter(dayjs(auxilius_start_date).date(1));
          }),
        ];
      }

      if (forecastHeader) {
        const currentForecast = forecastHeader.date_headers[0];

        // set current period closed months + QTD + YTD (spacers around)
        if (
          this.parseBudgetMonthToDate(currentForecast).month() % 3 &&
          actualsColDefs.length &&
          this.visibleColumns.historicals.months
        ) {
          const currentPeriodClosedMonths: (ColDef | ColGroupDef)[] = [
            actualsColDefs.pop() as ColDef | ColGroupDef,
          ];

          while (
            currentPeriodClosedMonths[0]?.headerName &&
            this.parseBudgetMonthToDate(currentPeriodClosedMonths[0]?.headerName).month() % 3 &&
            actualsColDefs.length
          ) {
            currentPeriodClosedMonths.unshift(actualsColDefs.pop() as ColDef | ColGroupDef);
          }

          actualsColDefs.push(...currentPeriodClosedMonths);
        }

        const snaphotPrefix = this.compareToValue ? '::SNAPSHOT' : '';
        const filedNameAffix = this.compareToValue ? 'EXPENSE_WP::' : '';

        const snapshotColumnParams = this.compareToValue
          ? {
              headerGroupComponent: AgHeaderDropdownComponent,
              headerGroupComponentParams: {
                toggleCb: this.HeaderDropdownService.registerGroupColumnChange.bind(
                  this.HeaderDropdownService
                ),
              },
            }
          : {};

        if (this.visibleColumns.historicals.quarters) {
          const qtd = {
            headerClass: 'ag-header-align-center justify-center',
            headerName: `${this.currentQuarter(currentForecast).replace('-', ' ')} (QTD)`,
            ...snapshotColumnParams,
            children: [
              {
                aggFunc: 'sum',
                cellClass: (p: CellClassParams) => [
                  getCellClass(this.selectedBudgetCurrencyType$.getValue())(p),
                  AuxExcelStyleKeys.BORDER_LEFT,
                  this.compareToValue ? '' : AuxExcelStyleKeys.BORDER_RIGHT,
                ],
                field: `${el.expense_type}::${this.currentQuarter(currentForecast)}`,
                headerClass: [
                  'ag-header-align-center',
                  AuxExcelStyleKeys.BORDER_LEFT,
                  this.compareToValue ? '' : AuxExcelStyleKeys.BORDER_RIGHT,
                ],
                headerName: 'Actuals',
                hide: false,
                minWidth: CellSize.xLarge,
                valueFormatter: agBudgetCurrencyFormatter(
                  this.selectedBudgetCurrencyType$.getValue()
                ),
                width: CellSize.xLarge,
              },
              {
                ...TableConstants.dynamicColumnProps(this.compareToValue || 'Plan'),
                aggFunc: 'sum',
                cellClass: getCellClass(this.selectedBudgetCurrencyType$.getValue()),
                field: this.compareToValue
                  ? `${el.expense_type}::${this.currentQuarter(currentForecast)}${snaphotPrefix}`
                  : `${this.currentQuarter(currentForecast)}::PLAN`,
                hide: !this.compareToValue,
                minWidth: CellSize.xLarge,
                valueFormatter: agBudgetCurrencyFormatter(
                  this.selectedBudgetCurrencyType$.getValue()
                ),
              },
              {
                aggFunc: 'sum',
                cellClass: getCellClass(this.selectedBudgetCurrencyType$.getValue()),
                cellRenderer: VariationStatusComponent,
                field: `${filedNameAffix}${this.currentQuarter(
                  currentForecast
                )}::VAR_COST${snaphotPrefix}`,
                headerClass: 'ag-header-align-center',
                headerName: '$',
                hide: !this.compareToValue,
                minWidth: CellSize.xLarge,
                valueFormatter: agBudgetCurrencyFormatter(
                  this.selectedBudgetCurrencyType$.getValue()
                ),
                width: CellSize.xLarge,
              },
              {
                aggFunc: 'sum',
                cellClass: [
                  'ag-cell-align-right',
                  'budget-percent',
                  AuxExcelStyleKeys.BORDER_RIGHT,
                ],
                cellRenderer: VariationStatusComponent,
                field: `${filedNameAffix}${this.currentQuarter(
                  currentForecast
                )}::VAR_PERC${snaphotPrefix}`,
                headerClass: ['ag-header-align-center', AuxExcelStyleKeys.BORDER_RIGHT],
                headerName: '%',
                hide: !this.compareToValue,
                minWidth: CellSize.large,
                valueFormatter: Utils.agPercentageFormatter,
                width: CellSize.large,
              },
            ].filter((col) => (this.compareToValue ? true : col.headerName === 'Actuals')),
          } as ColGroupDef;

          actualsColDefs.push(qtd);
        }

        const year = this.parseBudgetMonthToDate(currentForecast).year();

        if (this.visibleColumns.historicals.years) {
          const ytd = {
            headerClass: 'ag-header-align-center justify-center',
            headerName: `${year} (YTD)`,
            ...snapshotColumnParams,
            children: [
              {
                aggFunc: 'sum',
                cellClass: (p: CellClassParams) => [
                  getCellClass(this.selectedBudgetCurrencyType$.getValue())(p),
                  AuxExcelStyleKeys.BORDER_LEFT,
                  this.compareToValue ? '' : AuxExcelStyleKeys.BORDER_RIGHT,
                ],
                field: `${el.expense_type}::${this.currentYear(currentForecast)}`,
                headerClass: [
                  'ag-header-align-center',
                  AuxExcelStyleKeys.BORDER_LEFT,
                  this.compareToValue ? '' : AuxExcelStyleKeys.BORDER_RIGHT,
                ],
                headerName: 'Actuals',
                hide: false,
                minWidth: CellSize.xLarge,
                valueFormatter: agBudgetCurrencyFormatter(
                  this.selectedBudgetCurrencyType$.getValue()
                ),
                width: CellSize.xLarge,
              },
              {
                ...TableConstants.dynamicColumnProps(this.compareToValue || 'Plan'),
                aggFunc: 'sum',
                cellClass: getCellClass(this.selectedBudgetCurrencyType$.getValue()),
                field: this.compareToValue
                  ? `${el.expense_type}::${this.currentYear(currentForecast)}${snaphotPrefix}`
                  : `${this.currentYear(currentForecast)}::PLAN`,
                hide: true,
                minWidth: CellSize.xLarge,
                valueFormatter: agBudgetCurrencyFormatter(
                  this.selectedBudgetCurrencyType$.getValue()
                ),
              },
              {
                aggFunc: 'sum',
                cellClass: getCellClass(this.selectedBudgetCurrencyType$.getValue()),
                cellRenderer: VariationStatusComponent,
                field: this.compareToValue
                  ? `${el.expense_type}::${this.currentYear(
                      currentForecast
                    )}::VAR_COST${snaphotPrefix}`
                  : `${this.currentYear(currentForecast)}::VAR_COST`,
                headerClass: 'ag-header-align-center',
                headerName: '$',
                hide: true,
                minWidth: CellSize.xLarge,
                valueFormatter: agBudgetCurrencyFormatter(
                  this.selectedBudgetCurrencyType$.getValue()
                ),
                width: CellSize.xLarge,
              },
              {
                aggFunc: 'sum',
                cellClass: [
                  'ag-cell-align-right',
                  'budget-percent',
                  AuxExcelStyleKeys.BORDER_RIGHT,
                ],
                cellRenderer: VariationStatusComponent,
                field: this.compareToValue
                  ? `${el.expense_type}::${this.currentYear(
                      currentForecast
                    )}::VAR_PERC${snaphotPrefix}`
                  : `${this.currentYear(currentForecast)}::VAR_PERC`,
                headerClass: ['ag-header-align-center', AuxExcelStyleKeys.BORDER_RIGHT],
                headerName: '%',
                hide: true,
                minWidth: CellSize.large,
                valueFormatter: Utils.agPercentageFormatter,
                width: CellSize.large,
              },
            ].filter((col) => (this.compareToValue ? true : col.headerName === 'Actuals')),
          } as ColGroupDef;

          actualsColDefs.push(ytd);
        }
      }

      if (
        this.visibleColumns.historicals.months ||
        this.visibleColumns.historicals.quarters ||
        this.visibleColumns.historicals.years
      ) {
        defs.push(TableConstants.SPACER_COLUMN);
      }

      defs.push(...actualsColDefs);

      defs.push(TableConstants.SPACER_COLUMN);
      const actuals = actualsToDateColumnDef(
        this.visibleColumns.actuals_to_date,
        this.selectedBudgetCurrencyType$.getValue()
      ) as ColGroupDef;

      if (!this.flags().budgetActualsToDateUnits) {
        actuals.children = actuals.children.slice(1);
      }

      defs.push(actuals, TableConstants.SPACER_COLUMN);
      defs.push(
        remainingBudgetColDef(
          this.visibleColumns.remaining_budget,
          this.selectedBudgetCurrencyType$.getValue()
        )
      );

      if (
        this.visibleColumns.remaining_budget.costs ||
        this.visibleColumns.remaining_budget.perc ||
        this.visibleColumns.remaining_budget.units
      ) {
        defs.push(TableConstants.SPACER_COLUMN);
      }
    }

    if (forecastHeader) {
      const currentForecast = forecastHeader.date_headers[0];

      const currentPeriodChildren = [currentForecast];
      let slice = 1;

      while (
        currentPeriodChildren[currentPeriodChildren.length - 1] &&
        (this.parseBudgetMonthToDate(
          currentPeriodChildren[currentPeriodChildren.length - 1]
        ).month() +
          1) %
          3
      ) {
        if (!forecastHeader.date_headers[slice]) {
          break;
        }

        currentPeriodChildren.push(forecastHeader.date_headers[slice]);
        slice += 1;
      }

      if (
        (this.visibleColumns.current_period.quarters || this.visibleColumns.forecast.quarters) &&
        forecastHeader.date_headers[slice]?.startsWith('Q')
      ) {
        currentPeriodChildren.push(forecastHeader.date_headers[slice]);
        slice += 1;
      }

      const currentPeriodView = this.getCurrentPeriodView(currentPeriodChildren);

      currentPeriodView.forEach((forecastMonth) => {
        defs.push(forecastMonth);
      });

      // if we are showing the current period add space
      if (currentPeriodView.some((col: ColDef) => !col.hide)) {
        defs.push(TableConstants.SPACER_COLUMN);
      }

      if (!refresh) {
        const fYears = forecastHeader.date_headers.slice(1).reduce((acc: number[], col_header) => {
          const headerName = col_header.split('-').pop();

          if (headerName !== '' && !acc.includes(Number(headerName))) {
            acc.push(Number(headerName));
          }

          return acc;
        }, []);

        let arr: { enabled: boolean; label: number }[];

        if (Array.isArray(this.budgetGridYears)) {
          arr = fYears.map((year) => {
            return { enabled: !!this.budgetGridYears?.includes(year), label: year };
          });
        } else {
          arr = fYears.map((year, index) => ({ enabled: index < 2, label: year }));
        }

        this.years = uniqBy([...this.years, ...arr], 'label');
      }

      const year = this.parseBudgetMonthToDate(currentForecast).year();

      defs.push(...this.renderSnapshotForecast(forecastHeader.date_headers, slice, year));
    }

    const updatedColumns = this.updateExportHeaderGroupClasses(defs);

    const colSize = this.selectedVendor.value ? 350 : 250;

    this.autoGroupColumnDef = {
      ...this.autoGroupColumnDef,
      headerComponentParams: {
        ...this.autoGroupColumnDef.headerComponentParams,
        columnsToCollapse: attr.children.map((x: ColDef) => x.colId || x.field),
      },
      minWidth: colSize,
      width: colSize,
    };
    this.gridOptions$.next({
      ...this.gridOptions$.getValue(),
      autoGroupColumnDef: this.autoGroupColumnDef,
      columnDefs: [...this.defaultColumns, ...updatedColumns],
    });

    this.columnDefs = [...this.defaultColumns, ...updatedColumns];
    this.setSelectedYear();

    const uniqVendors = uniqBy(
      aggregated_budget_data
        .map((row) => row.vendor_id)
        .filter((vendorId) => vendorId !== undefined && vendorId !== ''),
      (vendorId) => vendorId
    ) as string[];

    this.gridUniqVendors.set(uniqVendors);

    if (aggregated_budget_data.length === 0) {
      const vendorId = this.selectedVendor.value || this.vendors()[0].id;

      if (vendorId) {
        this.activitiesModal.vendor_id.set(vendorId);
      }
    }

    setTimeout(() => {
      this.showGrid$.next(true);
      this.gridData$.next(aggregated_budget_data);
      this.cdr.markForCheck();
    }, 0);
  }

  modelUpdated(): void {
    this.modelUpdated$.next(true);
  }

  // The modelUpdated event might
  // be called many times in succession.
  // This listener will limit those calls so that
  // cellRenderers receive the latest event only.
  modelUpdatedListener(): void {
    this.modelUpdated$
      .pipe(takeUntilDestroyed(this.destroyRef), debounceTime(250))
      .subscribe((modelUpdated) => this.modelUpdatedDebounced$.next(modelUpdated));
  }

  onBudgetExportClick() {
    const vendorName = this.selectedVendorWithTotal()?.name;

    if (!vendorName && !this.columnDefs.find((cd) => cd.headerName === 'Cost Category')) {
      this.columnDefs.splice(1, 0, {
        field: 'cost_category',
        headerName: 'Cost Category',
        hide: true,
        rowGroup: true,
      });

      this.gridAPI?.setGridOption('columnDefs', this.columnDefs);
    }

    const trialName = this.mainQuery.getSelectedTrial()?.short_name || '';
    const hasView = false;
    const viewName = hasView ? '_VIEWHERE' : '';
    const dateStr = dayjs(new Date()).format('YYYY.MM.DD-HHmmss');
    const fileName = vendorName
      ? `${trialName}_${vendorName}${viewName}_Total Budget_${dateStr}.xlsx`
      : `${trialName}${viewName}_Total Budget_${dateStr}.xlsx`;

    const totalData = this.gridAPI?.getPinnedBottomRow(0)?.data;

    const columnKeys = this.budgetExportColumnIDs().filter(
      (key) =>
        key !== 'EXPENSE_QUOTE::LATEST' &&
        !key.startsWith('spacerColumn') &&
        key !== 'contract_direct_cost_currency'
    );

    const appendContent: ExcelExportParams['appendContent'] = [
      {
        cells: [
          {
            data: {
              type: 'String',
              value: 'Total',
            },
            styleId: [
              'total_row_header',
              AuxExcelStyleKeys.BORDER_LEFT,
              AuxExcelStyleKeys.BORDER_BOTTOM,
            ],
          },
        ],
      },
    ];

    let totalRowStyleId = 'total_row';

    if (!this.isVendorCurrency) {
      totalRowStyleId = 'total_row_USD';
    }

    if (this.selectedVendor.value && this.isVendorCurrency) {
      const orgCurrency = this.selectedVendorWithTotal()?.currency;

      if (orgCurrency) {
        totalRowStyleId = `total_row_${orgCurrency}`;
      }
    }

    if (
      this.numberOfVendorCurrencies === 1 &&
      this.selectedBudgetCurrencyType$.getValue() !== BudgetCurrencyType.USD
    ) {
      const orgCurrency = this.vendors()[0].currency;

      if (orgCurrency) {
        totalRowStyleId = `total_row_${orgCurrency}`;
      }
    }

    const vendorsColumns = ['display_label', 'group0', 'activity_name_label'];

    [
      'activity_id',
      'cost_category',
      ...vendorsColumns,
      ...(this.gridAPI
        ?.getAllDisplayedColumns()
        .map((col) => col.getColId())
        .filter(
          (colId) => !colId.startsWith('ag-Grid-AutoColumn') && !colId.startsWith('spacerColumn')
        ) || []),
    ].forEach((colId) => {
      const isPercentCol = [
        'var_percent',
        'wp_percentage',
        'remaining_percentage',
        '::VAR_PERC::SNAPSHOT',
        '::VAR_PERC',
      ].some((col) => !!colId.match(col));
      const isAttributeCol = colId.startsWith('custom_attr_');
      let safeValue = 0;

      if (
        this.selectedBudgetCurrencyType$.getValue() === BudgetCurrencyType.USD ||
        this.selectedVendor.value ||
        this.numberOfVendorCurrencies === 1
      ) {
        safeValue = ![
          'contract_unit_cost',
          'remaining_unit_num',
          'unit_cost',
          'unit_num',
          'uom',
          'wp_unit_num',
        ].includes(colId)
          ? totalData[colId] || 0
          : 0;
      }

      const divider = colId.includes('::VAR_PERC') ? 1 : 100;
      let value = isPercentCol ? decimalDivide(safeValue, divider) : safeValue;

      if (isAttributeCol) {
        value = 0;
      }

      appendContent[0].cells.push({
        data: { type: 'Number', value: `${value}` },
        styleId: [
          isPercentCol ? 'total_row_percent' : totalRowStyleId,
          AuxExcelStyleKeys.BORDER_BOTTOM,
          colId && this.isColumnHasStyleClass(colId, AuxExcelStyleKeys.BORDER_RIGHT)
            ? AuxExcelStyleKeys.BORDER_RIGHT
            : '',
          colId && this.isColumnHasStyleClass(colId, AuxExcelStyleKeys.BORDER_LEFT)
            ? AuxExcelStyleKeys.BORDER_LEFT
            : '',
        ],
      });
    });

    const exportOptions: ExcelExportParams = {
      ...this.excelOptions,
      appendContent:
        this.selectedBudgetCurrencyType$.getValue() === BudgetCurrencyType.USD ||
        this.selectedVendor.value ||
        this.numberOfVendorCurrencies === 1
          ? appendContent
          : [],
      columnKeys,
      fileName,
      prependContent: [
        {
          cells: [
            {
              data: { type: 'String', value: `Trial: ${trialName}` },
              mergeAcross: appendContent[0].cells.length - 1,
              styleId: 'trial_name',
            },
          ],
        },
      ],
      processCellCallback: (params: ProcessCellForExportParams): string => {
        const coldId = params.column.getColId();
        const costCategory = params.node?.data.cost_category;

        if (coldId.includes('unit') && costCategory === 'Discount') {
          return '0';
        }

        if (coldId.includes('uom') && !params.value) {
          return Utils.zeroHyphen;
        }

        const isPercentColumn = ['wp_percentage', 'remaining_percentage'].some((key) =>
          coldId.endsWith(key)
        );

        if (isPercentColumn) {
          return `${params.value / 100}`;
        }

        if (coldId.endsWith('VAR_COST') && isNaN(params.value)) {
          return '0';
        }

        return params.value;
      },
    } as ExcelExportParams;

    this.gridAPI?.exportDataAsExcel(exportOptions);
  }

  onBudgetUploadClick(vendorId?: string) {
    this.overlayService.openPopup<
      { onSuccess: (processEventId: string) => void; vendorId?: string },
      unknown,
      BudgetUploadComponent
    >({
      content: BudgetUploadComponent,
      data: {
        onSuccess: (processEventId: string) => {
          this.progressTrackerId.set(processEventId);
        },
        vendorId,
      },
      settings: {
        header: 'Upload Single Vendor Contract Budget',
        primaryButton: {
          action: (instance) => instance?.onUpload(),
          disabled: (instance) => !!instance?.uploadDisabled,
          label: 'Upload Budget Template',
          pendoTag: 'upload-budget-template-single',
        },
      },
    });
  }

  async onColumnChooser() {
    const resp = await firstValueFrom(
      this.overlayService.openPopup<
        { columns?: VisibleColumns },
        VisibleColumns,
        ColumnChooserLegacyComponent
      >({
        content: ColumnChooserLegacyComponent,
        data: { columns: JSON.parse(JSON.stringify(this.visibleColumns)) },
        settings: {
          header: 'Customize Vendor Budget View',
          primaryButton: {
            action: (instance) => instance?.onConfirm(),
            label: 'Confirm',
          },
        },
      }).afterClosed$
    );

    if (resp.data) {
      this.visibleColumns = resp.data;
      this.loadBudgetGridData(true);
      this.areUnsavedChanges = true;
      this.selectedCustom$.next('');
    }
  }

  onDataRendered(e: FirstDataRenderedEvent) {
    // only show the total row if toggled to USD, a specific Vendor Contract is selected, or there is only one currency
    this.gridAPI$.next(e.api);
    this.gridAPI = e.api;

    if (
      this.selectedBudgetCurrencyType$.getValue() === BudgetCurrencyType.USD ||
      this.selectedVendor.value !== '' ||
      this.numberOfVendorCurrencies === 1
    ) {
      this.setBottomTotalRow(this.gridAPI);
    } else {
      this.gridAPI?.setGridOption('pinnedBottomRowData', []);
      this.isTotalHidden = true;
    }

    // if there are multiple vendors in the trial but only one vendor has budget data, select that vendor
    if (this.vendors().length > 1) {
      const uniqVendors = this.gridUniqVendors();

      if (uniqVendors.length === 1) {
        this.activitiesModal.vendor_id.set(uniqVendors[0]);
      }
    }

    this.onSelect();
  }

  onFilterChanged(e: FilterChangedEvent) {
    this.setBottomTotalRow(e.api);
  }

  async onGridReady(event: GridReadyEvent) {
    this.gridAPI = event.api;
    this.gridAPIBehavior$.next(event.api);

    try {
      await this.toggleCategoriesByRouteParams();
      await this.openAttributesModalByRouteParams();
    } catch (error) {
      console.error(error);
    }
  }

  onModalClose = async (ref: ReturnType<typeof this.activitiesModal.openModal>) => {
    if (!ref) {
      return;
    }

    const closeEvent = await firstValueFrom(ref.afterClosed$);
    let vendor_id = this.activitiesModal.vendor_id();

    if (closeEvent.data) {
      if (!vendor_id) {
        // try to find the vendor_id in the rows
        closeEvent.data.rows.forEach((row) => {
          if (row.vendor_id) {
            vendor_id = row.vendor_id;
          }
        });
      }

      switch (closeEvent.data.type) {
        case 'close':
          break;
        case 'save': {
          const transaction_id = uuidv4();
          let updateColumnsSuccessful = true;

          if (
            closeEvent.data.deletedColumns.length ||
            closeEvent.data.renamedColumns.length ||
            closeEvent.data.addedColumns.length
          ) {
            updateColumnsSuccessful = await this.updateColumns({
              addedColumns: closeEvent.data.addedColumns,
              deletedColumns: closeEvent.data.deletedColumns,
              notes: closeEvent.data.notes,
              renamedColumns: closeEvent.data.renamedColumns,
              supporting_document_s3_bucket_keys:
                closeEvent.data.supporting_document_s3_bucket_keys,
              transaction_id,
              vendor_id,
            });
          }

          const budgetUpdated = await this.updateActivities({
            entity_id: vendor_id,
            isCategoryListChanged: closeEvent.data.isCategoryListChanged,
            notes: closeEvent.data.notes,
            rows: closeEvent.data.rows,
            supporting_document_s3_bucket_keys: closeEvent.data.supporting_document_s3_bucket_keys,
            temporaryCategories: closeEvent.data.temporaryCategories,
          });

          if (!budgetUpdated && updateColumnsSuccessful) {
            const tracking_id = uuidv4();

            if (
              await this.eventService.triggerEvent({
                entity_id: vendor_id,
                entity_type: EntityType.ORGANIZATION,
                payload: JSON.stringify({
                  createActivities: [],
                  deleteActivities: [],
                  note: closeEvent.data.notes,
                  supporting_document_s3_bucket_keys:
                    closeEvent.data.supporting_document_s3_bucket_keys,
                  updateActivities: [],
                }),
                tracking_id,
                transaction_id,
                type: EventType.INLINE_EDIT_BUDGET_ACTIVITIES,
              })
            ) {
              this.eventTrackerService.trackEvent(tracking_id).catch(console.error);
              this.overlayService.success('Budget update started');
            }
          }

          break;
        }
      }
    }
  };

  onMultipleVendorBudgetUploadClick() {
    this.overlayService.openPopup<
      { isMultiple?: boolean; onSuccess: (processEventId: string) => void; vendorId?: string },
      unknown,
      BudgetUploadComponent
    >({
      content: BudgetUploadComponent,
      data: {
        isMultiple: true,
        onSuccess: (processEventId: string) => {
          this.multiProgressTrackerId.set(processEventId);
        },
      },
      settings: {
        header: 'Upload Multiple Vendor Contract Budgets',
        primaryButton: {
          action: (instance) => instance?.onMultipleVendorUpload(),
          disabled: (instance) => !!instance?.multipleVendorUploadDisabled,
          label: 'Upload Budget Template',
          pendoTag: 'upload-budget-template-multi',
        },
      },
    });
  }

  onMultiTrackerIdChanged(trackerId: string) {
    this.multiProgressTrackerId.set(trackerId);

    if (!trackerId) {
      this.refreshGrid$.next(true);
    }
  }

  onSelect() {
    if (this.gridAPI) {
      this.gridAPI.setGridOption('isRowSelectable', (node) => this.isRowSelectable(node));
    }

    const nodes = this.gridAPI?.getSelectedNodes() || [];

    this.selectedNodeCount.set(nodes.length);

    if (nodes.length !== 0 && this.selectedVendor.value === '') {
      this.activitiesModal.vendor_id.set(nodes[0].data.vendor_id);
    }
  }

  onToggleBudgetGraph = () => {
    this.showBudgetGraph = !this.showBudgetGraph;
    localStorage.setItem('showBudgetGraph', `${this.showBudgetGraph}`);
  };

  onTrackerIdChanged(trackerId: string) {
    this.progressTrackerId.set(trackerId);

    if (!trackerId) {
      this.refreshGrid$.next(true);
    }
  }

  onVendorSelected(vendorId: string) {
    this.organizationStore.setActive(vendorId || null);
  }

  async openAttributesModalByRouteParams() {
    const { openModalAttributes } = await firstValueFrom(this.route.queryParams);

    if (!openModalAttributes) return;

    if (this.gridAPI) {
      this.gridAPI.selectAll();

      const rows = this.budgetModalRowMap(
        this.activitiesModal.mapSelectedRowsToModalData(this.gridAPI!)
      );

      const ref = this.activitiesModal.openModal({
        allBudgetActivities: this.budgetQueryData(),
        budgetData: this.gridData$.getValue(),
        editMode: !!rows.length,
        isActivityTabVisible: !rows.length,
        rows: rows,
        uomHide: uomHide$.getValue(),
      });

      if (ref) {
        await this.onModalClose(ref);
      }
    }

    // Clear router params
    await this.router.navigate([], {
      queryParams: {
        openModalAttributes: null,
      },
      queryParamsHandling: 'merge',
    });
  }

  openCustomList() {
    this.isCustomOpen = true;

    if (this.selectedCustom$.getValue() != null) {
      this.highlightedCustom.next(this.selectedCustomIndex);
    } else {
      this.highlightedCustom.next(0);
    }

    if (this.selectedCustomIndex != null) {
      this.highlightedCustom.next(this.selectedCustomIndex);
    } else {
      this.highlightedCustom.next(0);
    }

    this.cdr.detectChanges();
  }

  openList() {
    this.isYearsOpen = true;
  }

  openSnapshotModal = () => {
    this.overlayService.openPopup({
      modal: SnapshotModalComponent,
      settings: {
        header: 'Name Vendor Budget Snapshot',
      },
    });
  };

  private parseBudgetMonthToDate(period: string) {
    return dayjs(`01/${period.replace('-', '/')}`);
  }

  private periodSortingFunction(a: string, b: string) {
    const a_year = a.split('-').pop();
    const b_year = b.split('-').pop();

    if (Number(a_year) < Number(b_year)) {
      return -1;
    }

    if (Number(a_year) > Number(b_year)) {
      return 1;
    }

    if (a.split('-').length > b.split('-').length) {
      return -1;
    }

    if (a.split('-').length < b.split('-').length) {
      return 1;
    }

    const a_index = period_sorting.findIndex((el) => el.toUpperCase() === a.split('-').shift());
    const b_index = period_sorting.findIndex((el) => el.toUpperCase() === b.split('-').shift());

    if (a_index < b_index) {
      return -1;
    }

    if (a_index === b_index) {
      return 0;
    }

    return 1;
  }

  postProcessPopup: (params: PostProcessPopupParams) => void = (params: PostProcessPopupParams) => {
    const columnId = params.column ? params.column.getId() : undefined;

    if (columnId === 'account' || columnId === 'dept' || columnId === 'po') {
      const ePopup = params.ePopup;
      let oldTopStr = ePopup.style.top;
      let oldLeftStr = ePopup.style.left;

      // remove 'px' from the string (AG Grid uses px positioning)
      oldTopStr = oldTopStr.substring(0, oldTopStr.indexOf('px'));
      oldLeftStr = oldLeftStr.substring(0, oldLeftStr.indexOf('px'));
      const oldTop = parseInt(oldTopStr);
      const oldLeft = parseInt(oldLeftStr);
      const newTop = oldTop + 39;
      const newLeft = oldLeft + 35;

      ePopup.style.top = newTop + 'px';
      ePopup.style.left = newLeft + 'px';
    }
  };

  refreshTable = () => {
    this.loadBudgetGridData(true);
  };

  removeCustom(item: UserCustomView) {
    this.overlayService.openPopup<
      { message: string },
      boolean | undefined,
      ConfirmationModalComponent
    >({
      content: ConfirmationModalComponent,
      data: {
        message: `Are you sure you want to remove ${item?.name}?`,
      },
      settings: {
        header: 'Remove Custom View',
        primaryButton: {
          action: async (instance) => {
            instance?.ref.close();
            const response = await this.budgetService.removeUserCustomView(item.id);

            if (response) {
              await this.listCustomUserView();
              setTimeout(() => {
                this.loadBudgetGridData(true);
              }, 0);
              this.overlayService.success();
            }
          },
          label: 'Remove',
        },
      },
    });
  }

  private renderSnapshotForecast(date_headers: string[], slice: number, currentYear: number) {
    return date_headers
      .slice(slice)
      .filter((col_header) => {
        const year = col_header.split('-').pop();

        return this.years.find((e) => e.label === Number(year))?.enabled;
      })
      .filter((col_header) => {
        if (!isNaN(Number(col_header))) {
          return this.visibleColumns.forecast.years;
        }

        if (col_header.startsWith('Q')) {
          return this.visibleColumns.forecast.quarters;
        }

        return this.visibleColumns.forecast.months;
      })
      .map((forecastMonth) => {
        let headerName: string;
        let expandAll = false;

        if (forecastMonth.startsWith('Q')) {
          headerName = forecastMonth.replace('-', ' ');
        } else if (!isNaN(Number(forecastMonth))) {
          headerName = forecastMonth;
        } else {
          const date = this.parseBudgetMonthToDate(forecastMonth);

          headerName = `${Utils.SHORT_MONTH_NAMES[date.month()]} ${date.year()}`;

          expandAll = date.year() === currentYear;
        }

        const forecastHeaderParams = this.compareToValue
          ? {
              headerClass: [
                'ag-header-align-center bg-aux-gray-dark aux-black border-aux-gray-dark gray-dark-header-group flex items-center justify-center',
              ],
              headerGroupComponent: AgHeaderDropdownComponent,
              headerGroupComponentParams: {
                iconClass: 'text-black',
                toggleCb: this.HeaderDropdownService.registerGroupColumnChange.bind(
                  this.HeaderDropdownService
                ),
              },
            }
          : {
              headerClass: [
                'ag-header-align-center bg-aux-gray-dark aux-black gray-dark-header-group',
              ],
            };

        return {
          ...forecastHeaderParams,
          children: this.getForecastSubColumns(
            forecastMonth,
            this.compareToValue ? expandAll : false
          ),
          headerName,
        } as ColGroupDef;
      });
  }

  private async saveBudgetYears() {
    const years = [...this.years].reduce((acc: number[], el) => {
      if (!acc.includes(el.label) && el.enabled) {
        acc.push(el.label);
      }

      return acc;
    }, []);

    await firstValueFrom(
      this.gqlService.setTrialPreference$({
        preference_type: TrialPreferenceType.BUDGET_GRID_YEARS,
        value: JSON.stringify(years),
      })
    );

    this.budgetGridYears = years;
  }

  async saveCustomUserView() {
    const user = await this.authService.getLoggedInUser();
    const resp = this.overlayService.openPopup<
      unknown,
      { label?: string },
      BudgetCustomCreateComponent
    >({
      content: BudgetCustomCreateComponent,
      settings: {
        header: 'Name Custom View',
        primaryButton: {
          action: (instance) => instance?.saveText(),
          label: 'Save',
        },
      },
    });

    const event = await firstValueFrom(resp.afterClosed$);

    if (event.data?.label) {
      const data: CreateUserCustomViewInput = {
        metadata: JSON.stringify(this.visibleColumns),
        name: event.data.label,
        user_id: user?.getSub() || '',
        view_location: ViewLocation.VIEW_LOCATION_BUDGET_GRID,
      };
      const flag = await this.budgetService.saveUserCustomView(data);

      if (flag) {
        await this.listCustomUserView();
        this.customChanges({ ...data, name: event.data.label });
        setTimeout(() => {
          this.loadBudgetGridData(true);
        }, 0);
        this.areUnsavedChanges = false;
        this.overlayService.success();
      }
    }
  }

  async scrollToColumnByRouteParams() {
    const { scrollTo } = await firstValueFrom(this.route.queryParams);

    if (!scrollTo) return;

    if (scrollTo === 'forecast') {
      const gridInstance = this.gridAPIBehavior$.getValue();

      if (gridInstance) {
        const allColumns = gridInstance.getColumnDefs();
        const forecastColId = this.findFirstExpenseForecastColId(allColumns);

        if (forecastColId) {
          this.gridAPIBehavior$.getValue()?.ensureColumnVisible(forecastColId, 'start');
        }
      }
    } else {
      this.gridAPIBehavior$.getValue()?.ensureColumnVisible(scrollTo, 'start');
    }

    // Clear router params
    this.router
      .navigate([], {
        queryParams: {
          scrollTo: null,
          toggle: null,
          vendorId: null,
        },
        queryParamsHandling: 'merge',
      })
      .catch(console.error);
  }

  setBottomTotalRow(gridApi: GridApi) {
    this.isTotalHidden = false;
    const displayColumns = {
      ...gridApi?.getDisplayedRowAtIndex(gridApi?.getDisplayedRowCount() - 1)?.aggData,
      account_value: 0,
      dept_value: 0,
      po_value: 0,
    };

    Object.keys(displayColumns).forEach((key) => {
      const varPercSuffix = 'VAR_PERC::SNAPSHOT';

      if (key.includes('::VAR_COST::SNAPSHOT') && displayColumns[key]) {
        const keySetPrefix = key.split('::VAR_COST::SNAPSHOT')[0];
        const varPercKey = `${keySetPrefix}::${varPercSuffix}`;

        displayColumns[varPercKey] = displayColumns[`${keySetPrefix}::SNAPSHOT`]
          ? decimalDivide(
              displayColumns[`${keySetPrefix}::VAR_COST::SNAPSHOT`],
              displayColumns[`${keySetPrefix}::SNAPSHOT`],
              4
            )
          : 0;
      }
    });

    displayColumns.var_percent = decimalMultiply(
      decimalDivide(displayColumns.var_amount, displayColumns.baseline, 4),
      100,
      4
    );

    const budgetSum = decimalAdd(displayColumns.wp_cost || 0, displayColumns.remaining_cost || 0);

    displayColumns.wp_percentage = decimalMultiply(
      decimalDivide(displayColumns.wp_cost, budgetSum),
      100,
      2
    );

    displayColumns.remaining_percentage = decimalDifference(100, displayColumns.wp_percentage, 2);

    gridApi?.setGridOption('pinnedBottomRowData', [
      merge(
        {
          activity_name: 'Total',
        },
        displayColumns
      ),
    ]);
  }

  private setSelectedYear() {
    let numberOfYearsEnabled = 0;

    this.years.forEach((year) => {
      if (year.enabled) {
        numberOfYearsEnabled += 1;
      }
    });

    if (numberOfYearsEnabled === 0) {
      this.selectedYear = 'None';
    } else if (numberOfYearsEnabled < this.years.length) {
      this.selectedYear = `${numberOfYearsEnabled} Selected`;
    } else {
      this.selectedYear = 'All';
    }
  }

  private setUserPermissions(): void {
    combineLatest([
      this.authService.isAuthorized$({
        permissions: [PermissionType.PERMISSION_UPLOAD_BUDGET],
        sysAdminsOnly: false,
      }),
    ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([userHasUploadBudgetPermission]) => {
        this.userHasUploadBudgetPermission = userHasUploadBudgetPermission;
      });
  }

  private sortingForDefault(
    customValues: (UserCustomView & {
      showLine: boolean;
    })[]
  ) {
    const data: (UserCustomView & {
      showLine: boolean;
    })[] = [];
    const nCustomValues = customValues.filter((x) => x.is_custom);

    customValues.forEach((x) => {
      if (x.is_custom) {
        return;
      }

      switch (x.name) {
        case 'Forecast Only - Months':
          data[6] = x;
          break;
        case 'Forecast Only - Quarters':
          data[7] = x;
          break;
        case 'Forecast Only - Years':
          data[8] = x;
          break;
        case 'Historical Only - Months':
          data[3] = x;
          break;
        case 'Historical Only - Quarters':
          data[4] = x;
          break;
        case 'Historical Only - Years':
          data[5] = x;
          break;
        case 'Monthly':
          data[0] = { ...x, showLine: true };
          break;
        case 'Quarterly':
          data[1] = x;
          break;
        case 'Yearly':
          data[2] = x;
          break;
        default:
          break;
      }
    });

    return [...nCustomValues, ...data];
  }

  async toggleCategoriesByRouteParams() {
    const { toggle } = await firstValueFrom(this.route.queryParams);

    if (!toggle) return;

    if (this.gridAPI) {
      this.gridAPI.forEachNode((node) => {
        if (
          node.level === 0
            ? true
            : !!node.key && node.key.toLowerCase().includes(toggle) && node.level === 1
        ) {
          node.expanded = true;
        }
      });
      this.gridAPI.onGroupExpandedOrCollapsed();
    }

    // Clear router params
    this.router
      .navigate([], {
        queryParams: {
          scrollTo: null,
          toggle: null,
          vendorId: null,
        },
        queryParamsHandling: 'merge',
      })
      .catch(console.error);
  }

  async updateActivities({
    entity_id,
    isCategoryListChanged,
    notes,
    rows,
    supporting_document_s3_bucket_keys,
    temporaryCategories,
  }: {
    entity_id: string;
    isCategoryListChanged: boolean;
    notes: string;
    rows: BeActivitiesAttributesModalRowData[];
    supporting_document_s3_bucket_keys: null | string[];
    temporaryCategories: BeInlineCategoryDropdownOption[];
  }) {
    const trialId = this.mainQuery.getValue().trialKey;
    const trialVendorPath = `>${trialId}>${entity_id}`;
    const createdActivities: ActivityWithAttributes[] = [];
    const updatedActivities: ActivityWithAttributes[] = [];
    const deletedActivities: ActivityWithAttributes[] = [];

    rows.forEach((row) => {
      let activity_type: ActivityType;
      let activity_sub_type: ActivitySubType | undefined;
      let category_full_path: string;

      if (isCategoryListChanged) {
        category_full_path =
          temporaryCategories.find((category) => category.id === row.category)?.fullPath || '';
      } else {
        category_full_path =
          this.activitiesModal.categories()?.find((category) => category.id === row.category)
            ?.fullPath || '';
      }

      switch (row.activity_type) {
        case 'ACTIVITY_DISCOUNT':
        case 'ACTIVITY_INVESTIGATOR':
        case 'ACTIVITY_PASSTHROUGH':
        case 'ACTIVITY_SERVICE':
          activity_type = row.activity_type as ActivityType;
          break;
        case 'ACTIVITY_INVESTIGATOR_PATIENT_INVOICEABLES':
        case 'ACTIVITY_INVESTIGATOR_PATIENT_VISITS':
        case 'ACTIVITY_INVESTIGATOR_SITE_INVOICEABLES':
          activity_type = ActivityType.ACTIVITY_INVESTIGATOR;
          activity_sub_type = row.activity_type as ActivitySubType;
          break;
        default:
          activity_type = ActivityType.ACTIVITY_SERVICE;
          break;
      }

      const newData = {
        activity_sub_type,
        activity_type,
        attributes: Object.entries(row.attributes).map(([key, value]) => {
          return {
            attribute_name: key.startsWith('custom_attr_')
              ? decodeURIComponent(atob(key.split('custom_attr_')[1]))
              : key,
            attribute_value: value,
          };
        }) as BudgetActivityAttributes[],
        category_full_path: `${trialVendorPath}${category_full_path}`,
        category_id: row.category,
        display_label: row.display_label || '',
        id: row.id,
        name: row.activity_name || '',
        unit_cost: <number>row.unit_cost || 0,
        unit_num: <number>row.unit_num || 0,
        uom: row.uom || '',
      };

      if (row.deleted) {
        deletedActivities.push(newData);

        return;
      }

      if (!row.changed || !row.activity_name) {
        return;
      }

      if (row.isGenerated) {
        createdActivities.push({ ...newData, id: '' });
      } else {
        updatedActivities.push(newData);
      }
    });

    localStorage.setItem('anyEditActivities', 'true');

    if (
      createdActivities.length ||
      updatedActivities.length ||
      deletedActivities.length ||
      isCategoryListChanged
    ) {
      const categories: { [key: string]: AuxBudgetCategoryData[] } = {};

      if (isCategoryListChanged) {
        const filteredCategories: BeInlineCategoryDropdownOption[] = temporaryCategories
          .map((category, index) => ({
            ...category,
            sourceIndex: index + 2,
          }))
          .filter((category) => {
            return (
              category.categoryType !== CategoryType.CATEGORY_INVESTIGATOR &&
              category.categoryType !== CategoryType.CATEGORY_DISCOUNT &&
              category.fullPath !== ''
            );
          });

        filteredCategories.forEach((category) => {
          categories[`/${category.categoryType}/${trialVendorPath}${category.fullPath}`] = [
            {
              __typename: 'AuxBudgetCategoryData',
              attributes: '[{}]',
              categories: '[{}]',
              category_type: category.categoryType || CategoryType.CATEGORY_SERVICE,
              direct_expenses_note: '',
              display_label: '',
              display_order: 0,
              full_path: `${trialVendorPath}${category.fullPath}`,
              item_count: 0,
              //fields with default values
              item_label: '0',
              item_order: 0,
              name: category.name,
              parent_path: `${trialVendorPath}${category.path}`,
              previous_full_path: category.isRenamed
                ? this.getCategoryPreviousFullPath(category, trialVendorPath)
                : '', // only populate if the name of the category was updated
              source_index: category.sourceIndex || 0,
              trial_id: trialId,
              vendor_id: entity_id || '',
            },
          ];
        });
      }

      const tracking_id = uuidv4();

      if (
        await this.eventService.triggerEvent({
          entity_id,
          entity_type: EntityType.ORGANIZATION,
          payload: JSON.stringify({
            categories,
            createActivities: createdActivities,
            deleteActivities: deletedActivities,
            note: notes,
            supporting_document_s3_bucket_keys: supporting_document_s3_bucket_keys,
            updateActivities: updatedActivities,
          }),
          tracking_id,
          type: EventType.INLINE_EDIT_BUDGET_ACTIVITIES,
        })
      ) {
        this.eventTrackerService.trackEvent(tracking_id).catch(console.error);
        this.overlayService.success('Budget update started');
      }

      return true;
    }

    return false;
  }

  async updateColumns({
    addedColumns,
    deletedColumns,
    notes,
    renamedColumns,
    supporting_document_s3_bucket_keys,
    transaction_id,
    vendor_id,
  }: {
    addedColumns: string[];
    deletedColumns: string[];
    notes: string;
    renamedColumns: { newValue: string; oldValue: string }[];
    supporting_document_s3_bucket_keys: null | string[];
    transaction_id: string;
    vendor_id: string;
  }) {
    for (const name of deletedColumns) {
      await firstValueFrom(
        this.gqlService.removeBudgetAttribute$({
          budget_type: BudgetType.BUDGET_PRIMARY,
          name,
          note: notes,
          supporting_document_s3_bucket_keys,
          transaction_id,
          vendor_id,
        })
      );
    }

    for (const name of addedColumns) {
      await firstValueFrom(
        this.gqlService.createBudgetAttribute$({
          budget_type: BudgetType.BUDGET_PRIMARY,
          name,
          note: notes,
          supporting_document_s3_bucket_keys,
          transaction_id,
          vendor_id,
        })
      );
    }

    for (const { newValue, oldValue } of renamedColumns) {
      const { errors } = await firstValueFrom(
        this.gqlService.renameBudgetAttribute$({
          budget_type: BudgetType.BUDGET_PRIMARY,
          name: oldValue,
          new_name: newValue,
          note: notes,
          supporting_document_s3_bucket_keys,
          transaction_id,
          vendor_id,
        })
      );

      if (errors.length) {
        this.overlayService.error(String(errors));

        return false;
      }
    }

    return true;
  }

  private updateExportHeaderGroupClasses(
    columns: (ColDef | ColGroupDef)[]
  ): (ColDef | ColGroupDef)[] {
    let exportColumnIndex = 0;

    return columns.map((column) => {
      if (!this.isSpacerColumn(column) && !this.isAllChildrenHiddenInHeaderGroup(column)) {
        let headerClass = '';

        if (column.headerClass) {
          if (isArray(column.headerClass)) {
            headerClass = column.headerClass.reduce((accum, className) => {
              return `${accum} ${className}`;
            }, '');
          } else if (isString(column.headerClass)) {
            headerClass = column.headerClass;
          }
        }

        exportColumnIndex += 1;

        return {
          ...column,
          headerClass: [
            headerClass,
            AuxExcelStyleKeys.BORDER_LEFT,
            AuxExcelStyleKeys.BORDER_RIGHT,
            !isEven(exportColumnIndex) ? AuxExcelStyleKeys.ALTERNATE : '',
          ],
        };
      }

      return column;
    });
  }

  async yearChanged($event: boolean, label: number) {
    const year = this.years.find((el) => el.label === label);

    if (year) {
      year.enabled = $event;
    }

    await this.saveBudgetYears();
    this.loadBudgetGridData(true);
    this.setSelectedYear();
  }
}
